//PJQProjectWall-Live
//PJQProjectWall-Live
var tbITB = null,
	tbITBSearch = null,
	tbPaging = null,
	gridITB = null,
	gridITBGroupBy = 'view_default',
	tvPMPrivate = null,
	gridITBSortOrder = 'CompanyName',
	gridITBSortDirection = 'asc',
	gridITBSortIndex = 0,
	cmITB_NONE = null,
	cmITB_P = null,
	cmITB_PM = null,
	cmITB_PMR = null,
	cmITB_PMH = null,
	cmITB_PMH3 = null,
	cmITB_G = null,
	scl = null,
	statusSubGrid = null,
	ssl = '',
	searchGroupList = '',
	subgridCheckedRows = '',
	subGridLast = null,
	gridBusy = null,
	enableDeclined = false,
	filterGroupTree = null,
	isCreatingMessage = false,
	msgEditor = null,
	pmTemplate = null,
	scrPreview = 0,
	tRefreshPreview = null,
	pmTemplateSelected = null,
	pmCopy = null,
	pmUploadInit = false,
	tbITBLastAction = null,
	dlgPM = null,
	invalidProjectContacts = [],
	statusChange = null,
	lastStatus = null,
	lastProjectContactId = null,
	lastContactId = null,
	filterSelectedOnly = false,
	filterUnsent = false,
	fuPM = null;

window.gridContactGroups = null;

function FaxAlways() {
	if (jQuery('#project-message-send-fax').prop('checked'))
		jQuery('#project-message-send-email-or-fax,#project-message-send-fax-if-email-fails').prop('checked', false);
}

function OptionalFax() {
	if (jQuery('#project-message-send-email-or-fax').prop('checked') || jQuery('#project-message-send-fax-if-email-fails').prop('checked'))
		jQuery('#project-message-send-fax').prop('checked', false);
}

function cleanWordPaste(input) {
	// 1. remove line breaks / Mso classes
	var stringStripper = /(\n|\r| class=(")?Mso[a-zA-Z]+(")?)/g;
	var output = input.replace(stringStripper, ' ');
	// 2. strip Word generated HTML comments
	var commentSripper = new RegExp('<!--(.*?)-->', 'g');
	output = output.replace(commentSripper, '');
	var tagStripper = new RegExp('<(/)*(meta|link|\\?xml:|st1:|o:)(.*?)>', 'gi');
	// 3. remove tags leave content if any
	output = output.replace(tagStripper, '');
	// 4. Remove everything in between and including tags '<style(.)style(.)>'
	var badTags = ['script', 'applet', 'embed', 'noframes', 'noscript'];

	for (var i = 0; i < badTags.length; i++) {
		tagStripper = new RegExp('<' + badTags[i] + '.*?' + badTags[i] + '(.*?)>', 'gi');
		output = output.replace(tagStripper, '');
	}
	// 5. remove attributes ' style="..."'
	var badAttributes = ['start'];
	for (var i = 0; i < badAttributes.length; i++) {
		var attributeStripper = new RegExp(' ' + badAttributes[i] + '="(.*?)"', 'gi');
		output = output.replace(attributeStripper, '');
	}
	return output;
}

function cleanWordPasteForReport(input) {
	// 1. remove line breaks / Mso classes
	input = input.replace(/(?:\r\n|\r|\n)/g, '<br />');
	var stringStripper = /(\n|\r| class=(")?Mso[a-zA-Z]+(")?)/g;
	var output = input.replace(stringStripper, ' ');
	// 2. strip Word generated HTML comments
	var commentSripper = new RegExp('<!--(.*?)-->', 'g');
	output = output.replace(commentSripper, '');
	var tagStripper = new RegExp('<(/)*(meta|link|\\?xml:|st1:|o:)(.*?)>', 'gi');
	// 3. remove tags leave content if any
	output = output.replace(tagStripper, '');
	// 4. Remove everything in between and including tags '<style(.)style(.)>'
	var badTags = ['script', 'applet', 'embed', 'noframes', 'noscript'];

	for (var i = 0; i < badTags.length; i++) {
		tagStripper = new RegExp('<' + badTags[i] + '.*?' + badTags[i] + '(.*?)>', 'gi');
		output = output.replace(tagStripper, '');
	}
	// 5. remove attributes ' style="..."'
	var badAttributes = ['start'];
	for (var i = 0; i < badAttributes.length; i++) {
		var attributeStripper = new RegExp(' ' + badAttributes[i] + '="(.*?)"', 'gi');
		output = output.replace(attributeStripper, '');
	}

	var tmp = document.createElement("DIV");
	tmp.innerHTML = output;
	var tmpOutput = tmp.textContent || tmp.innerText || "";
	tmpOutput = tmpOutput.replace('\t', '').replace('\n', '');
	if (tmpOutput.length == 0)
		output = tmpOutput;

	return output;
}

function EditContact(projectContactId, callback) {
	new PJQ.ajax.Request({
		endpoint: "/Project/GetProjectContactInfo",
		isPascal: true,
		data: {
			projectContactId: parseInt(projectContactId)
		}
	}).post().done(function (data) {
		if (callback) {
			callback(data);
		}
		else {
			EditContactC(data);
		}
	}).fail(function () {
	});
}

function EditContactC(contact) {
	PJQ.templating.TemplateRenderer.renderTemplate(false, new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALLADMIN, 'EditContact', {
		isOldModule: true,
		isJsRender: true
	}), $('#dialog-edit-contact'), contact, function () {
		if (typeof PJQProjectWallAdminEditContactInitialize == 'function')
			PJQProjectWallAdminEditContactInitialize(contact);

		var buttonList =
			{
				"Add New Contact to Company": function () {
					myInfoSave('itbnew');
				},
				"Save Changes": function () {
					myInfoSave('itb');
				}
			};

		if (contact.IsDirectoryContact)
			buttonList =
				{
					"Save Changes": function () {
						myInfoSave('itb');
					}
				};

		if (settings.IsAddressBookRO)
			buttonList = {};
		var dlg = jQuery("#dialog-edit-contact").dialog({
			resizable: false,
			height: 600,
			width: 800,
			title: 'Contact Details',
			modal: true,
			draggable: false,
			buttons: buttonList

		});
		dlg.parent().appendTo($("Form[name='Form']"));
	});
}

function EditContactCNew(contact) {
	PJQ.templating.TemplateRenderer.renderTemplate(false, new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALLADMIN, 'EditContact', {
		isOldModule: true,
		isJsRender: true
	}), $('#dialog-edit-contact'), contact, function () {
		if (typeof PJQProjectWallAdminEditContactInitialize == 'function')
			PJQProjectWallAdminEditContactInitialize(contact);

		var buttonList =
			{
				"Save Changes and Add to Project": function () {
					myInfoSave('itbadd', true, false);
				},
				"Save Changes": function () {
					myInfoSave('itb');
				}
			};

		if (settings.IsAddressBookRO)
			buttonList = {};
		var dlg = jQuery("#dialog-edit-contact").dialog({
			resizable: false,
			height: 600,
			width: 800,
			title: 'Contact Details',
			modal: true,
			draggable: false,
			buttons: buttonList

		});
		dlg.parent().appendTo($("Form[name='Form']"));
	});
}

function SendPM2c(response) {
	resp = jQuery.parseJSON(response);
	fileUploadCounter = 0;
	PMUploadRefresh(resp.FileUploadGuid);

	settings.UnsentCount = resp.UnsentCount;
	HideBusy();
	ClearAllCheckboxes();
	filterUnsent = false;
	if ((settings.UnsentCount > 0) && (gridITBGroupBy != 'view_message')) {
		jQuery('#grid-toolbar-itb-unsent').html("<p style='padding-left: 4px;'><span class='ui-icon ui-icon-alert'></span><strong>Note:</strong>&nbsp;<a href='javascript:void(0)' style='text-decoration: underline;' onclick='FilterUnsent()'>There are " + resp.UnsentCount.toString() + " Participants that have not been sent a message.  Click here to filter them.</a></p>");
		jQuery('#grid-toolbar-itb-unsent').show();
	}
	else
		jQuery('#grid-toolbar-itb-unsent').hide();

	isCreatingMessage = false;
	settings.IsPMAttachPrivateOpen = false;
	settings.PMPrivateFolderIds = '';

	if (filterSelectedOnly) {
		FilterClearAllClick();
	}


	newsfeedResultIndex = 1;
	if (jQuery('#tabsMain').tabs('option', 'active') != 0)
		jQuery('#tabsMain').tabs('option', 'active', 0);
	jQuery('#project-newsfeed').html("<div id='newsfeed-loading'><img src='/i/ajax-loader.gif' alt='Loading...' style='vertical-align: middle;' /><span style='font-weight: bold;vertical-align: middle; padding-left: 6px;'>Loading...</span></div>");

	PanteraScript.PanteraScriptService.GetProjectNewsfeedAdmin(PJQ.app.session.id, newsfeedResultIndex, newsfeedPageSize, NewsfeedC, onScriptError);
}

function ValidatePM() {
	var hasErrors = false;
	var i = 0;
	jQuery('label.pjq-errortext', jQuery('#project-message-body').parent()).remove();
	var bodyframe = null;
	var frames = document.getElementsByTagName("iframe");
	for (i = 0; i < frames.length; i++)
		if (frames[i].className == 'dhxeditor_mainiframe_dhx_web')
			bodyframe = frames[i];

	var doc = bodyframe.contentDocument;
	if (doc == undefined || doc == null)
		doc = bodyframe.contentWindow.document;

	doc.body.style.backgroundColor = 'white';
	jQuery('#project-message-subject').removeClass('pjq-errortext');
	jQuery('label.pjq-errortext', jQuery('#project-message-subject').parent()).remove();
	jQuery('#project-message-quickadd').removeClass('pjq-errortext');
	jQuery('label.pjq-errortext', jQuery('#project-message-quickadd').parent()).remove();
	var emails2 = jQuery('#project-message-quickadd').val().replace(';', ',').replace(' ', '').split(',');
	var emailError = false;
	if (emails2.length > 0 && emails2[0].length > 0) {
		for (i = 0; i < emails2.length; i++) {

			if (!PJQ.helpers.validators.validateEmail(emails2[i], true).success) {
				jQuery('#project-message-quickadd').parent().append("<label for='project-message-quickadd' class='pjq-errortext'>Invalid Email Address(es) were entered.</label>");
				jQuery('#project-message-quickadd').addClass('pjq-errortext');
				hasErrors = true;
				emailError = true;
			}
		}
	}
	if (!emailError && (emails2.length < 1 || emails2[0].trim().length == 0) && settings.SelectectContactsTemp.length == 0) {
		jQuery('#project-message-quickadd').parent().append("<label for='project-message-quickadd' class='pjq-errortext'>Please select/enter at least one recipient.</label>");
		jQuery('#project-message-quickadd').addClass('pjq-errortext');
		hasErrors = true;
	}

	var subject = jQuery('#project-message-subject').val().trim();
	if (!subject || subject.length == 0) {
		jQuery('#project-message-subject').parent().append("<label for='project-message-subject' class='pjq-errortext'>Please enter a Subject.</label>");
		jQuery('#project-message-subject').addClass('pjq-errortext');
		hasErrors = true;
	}

	var templateX = cleanWordPaste(msgEditor.getContent().trim());
	var spaceMatch = templateX.match(/&nbsp;/g);
	if (null != spaceMatch && spaceMatch.length == templateX.length / 6)
		templateX = '';

	if (!templateX || templateX.length == 0) {
		jQuery('#project-message-body').parent().append("<label class='pjq-errortext'>Please enter a Message.</label>");
		doc.body.style.backgroundColor = 'orange';
		hasErrors = true;
	}

	return hasErrors;
}

function GetCheckedPrivateFolders() {
	var sharePrivateFolders = new Array();
	if (settings.IsPMAttachPrivate && tvPMPrivate != null) {
		var checkedItemList = tvPMPrivate.getAllChecked().split(',');
		var i = 0;
		for (i = 0; i < checkedItemList.length; i++) {
			if (!checkedItemList[i] || checkedItemList[i] == '')
				continue;

			if (tvPMPrivate.isItemChecked(tvPMPrivate.getParentId(checkedItemList[i])) == '1' && tvPMPrivate.getParentId(checkedItemList[i]) != '2')
				continue;
			else
				sharePrivateFolders.push(checkedItemList[i]);
		}
	}
	if (sharePrivateFolders.length == 0) {
		sharePrivateFolders.push('');
	}
	return sharePrivateFolders.join(',');
}

function SendPM() {
	var hasErrors = ValidatePM();
	if (hasErrors)
		return;

	jQuery('#project-message-send').button('option', 'disabled', true);

	var responseType = jQuery('#project-message-response-type').val();

	if (responseType == 'PROJECT')
		PanteraScript.PanteraScriptService.CheckProjectMessageRecipients(PJQ.app.session.id, settings.SelectectContactsTemp.join(), SendPMc, onScriptError);
	else
		SendPM2();
}

function SendPMc(response) {
	var nonPending = parseInt(response);
	if (nonPending > 0) {
		jQuery('#project-message-window').parent().hide();
		jQuery('#project-message-send').button('option', 'disabled', false);

		showInfoDialogPWall('Project Status Warning', 'Participants in your selection have a non-PENDING status.  If you send this message, it will reset their status back to PENDING.  Do you want to continue?', 'ui-icon-alert', 'send-itb-statusreset');
	}
	else
		SendPM2();
}

function SendPM2() {
	var hasErrors = ValidatePM();
	if (hasErrors)
		return;

	if (tRefreshPreview)
		clearTimeout(tRefreshPreview);

	jQuery(msgEditor.edDoc.body).off('paste');
	dlgPM.dialog('close');
	ShowBusy('Sending...');

	var emails2 = jQuery('#project-message-quickadd').val().replace(';', ',').split(',');
	if (emails2.length > 0)
		for (i = emails2.length; i >= 0; i--) {
			if (emails2[i]) {
				emails2[i] = emails2[i].trim();
			}
			if (!emails2[i])
				emails2.splice(i, 1);
		}

	var quickAddList = emails2.join();

	var subject = jQuery('#project-message-subject').val();
	var templateKey = jQuery('#project-message-type').val();
	var responseType = jQuery('#project-message-response-type').val();
	var responseDueDate = jQuery('#project-message-response-due').val();
	var responseDueASAP = false;
	if (jQuery('#project-message-response-due-asap').prop('checked'))
		responseDueASAP = true;
	var isAllowPublic = jQuery('#project-message-allow-comments').prop('checked');
	var sendOptions = "EMAIL";

	if (jQuery('#project-message-send-fax').prop('checked'))
		sendOptions += ',FAX_AND_EMAIL';
	if (jQuery('#project-message-send-email-or-fax').prop('checked'))
		sendOptions += ',EMAIL_OR_FAX';
	if (jQuery('#project-message-send-fax-if-email-fails').prop('checked'))
		sendOptions += ',EMAIL_FAX_FAILS';

	var template = cleanWordPaste(msgEditor.getContent());

	pmTemplate.ProjectMessage.MessageBody = template;
	pmTemplate.ProjectMessage.ResponseType = 'N/A';
	if (jQuery('#project-message-response-type').val() == 'PROJECT')
		pmTemplate.ProjectMessage.ResponseType = 'ACCEPT/DECLINE';
	else
		pmTemplate.ProjectMessage.ResponseType = 'YES/NO';

	pmTemplate.ProjectMessage.BidDueDate = jQuery('#project-message-response-due').val();
	if (jQuery('#project-message-response-due-asap').prop('checked'))
		pmTemplate.ProjectMessage.BidDueDate = 'ASAP';

	template = TranslateTokens(template);

	var bodyTemplate = $.templates(template);

	var template2 = jQuery('#project-message-subject').val();
	template2 = TranslateTokens(template2);

	var subjectTemplate = $.templates(template2);
	jQuery('#project-message-spreview').html();
	jQuery('#project-message-spreview').attr('title', subjectTemplate.render(pmTemplate));
	jQuery('#project-message-preview').html(bodyTemplate.render(pmTemplate));

	PanteraScript.PanteraScriptService.SendProjectMessage(PJQ.app.session.id, settings.SelectectContactsTemp.join(), quickAddList, jQuery('#project-message-subject').val(), cleanWordPaste(msgEditor.getContent()), templateKey, responseType, responseDueDate, responseDueASAP, sendOptions, isAllowPublic, GetCheckedPrivateFolders(), SendPM2c, onScriptError);
}

function PMAddFromAB(response) {
	tbITBLastAction = 'add_contacts_from_abpm';

	var quickAddList = jQuery('#project-message-quickadd').val();
	var subject = jQuery('#project-message-subject').val();
	var templateKey = jQuery('#project-message-type').val();
	var responseType = jQuery('#project-message-response-type').val();
	var responseDueDate = jQuery('#project-message-response-due').val();
	var responseDueASAP = false;
	if (jQuery('#project-message-response-due-asap').prop('checked'))
		responseDueASAP = true;
	var isAllowPublic = jQuery('#project-message-allow-comments').prop('checked');
	var sendOptions = "EMAIL";
	if (jQuery('#project-message-send-fax').prop('checked'))
		sendOptions += ',FAX_AND_EMAIL';
	if (jQuery('#project-message-send-email-or-fax').prop('checked'))
		sendOptions += ',EMAIL_OR_FAX';
	if (jQuery('#project-message-send-fax-if-email-fails').prop('checked'))
		sendOptions += ',EMAIL_FAX_FAILS';

	PanteraScript.PanteraScriptService.CreateProjectContactTempContext(pjqSessionId, settings.SelectectContactsTemp.join(), quickAddList, subject, cleanWordPaste(msgEditor.getContent()), templateKey, responseType, responseDueDate, responseDueASAP, sendOptions, isAllowPublic, !jQuery('#project-message-private-folders').hasClass('pjq-hidden'), GetCheckedPrivateFolders(), tbITBc, onScriptError);
}

function PMAddFromAP() {
	$('#project-message-window').closest('.ui-dialog').addClass('hidden');
	new PJQ.views.projectParticipants.AddParticipantsFromProjectModal({
		model: PJQ.app.session.project,
		isBidFormsEnabled: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_BID_FORMS),
		projectResponses: settings.ProjectStatus,
		onSave: _.bind(function (data) {
			$('#project-message-window').closest('.ui-dialog').removeClass('hidden');
			settings.SelectectContactsTemp = settings.SelectectContactsTemp.concat(data);
			jQuery('div[aria-describedby="project-message-window"] span.ui-dialog-title').html(GetNewMessageDialogTitle());
			InitializeGridITB(gridITBGroupBy);
		}, this),
		onCancel: function () {
			$('#project-message-window').closest('.ui-dialog').removeClass('hidden');
		}
	});
}

function PMAddFromPL(response) {
	isCreatingMessage = true;
	var iapo = settings.IsPMAttachPrivateOpen = !jQuery('#project-message-private-folders').hasClass('pjq-hidden');
	var pfis = settings.PMPrivateFolderIds = GetCheckedPrivateFolders();
	dlgPM.dialog("close");
	settings.IsPMAttachPrivateOpen = iapo;
	settings.PMPrivateFolderIds = pfis;

	tbITB.disableItem("new");
	tbITB.disableItem("add_default");

	let newItbBtn = jQuery('#create-new-itb');
	if (newItbBtn.hasClass('ui-button')) {
		newItbBtn.button('option', 'label', resumeLabel);
	}
	else {
		newItbBtn.find('.btn-text').text(resumeLabel);
	}

	if (filterSelectedOnly) {
		tbITBSearch.setItemText('info', '');
		jQuery('#grid-toolbar-itb').show();
		tbITBSearch.showItem('export');
		tbITBSearch.showItem('export_sep');

		if (gridITBGroupBy == 'view_message') {
			tbITBSearch.showItem('export_messages_sep');
			tbITBSearch.showItem('export_messages');
		}

		filterSelectedOnly = false;
		InitializeGridITB(gridITBGroupBy);
	}

	if (jQuery('#tabsMain').tabs('option', 'active') != 2)
		jQuery('#tabsMain').tabs('option', 'active', 2);
}

function tbITBc(response) {
	var url = '';

	if (tbITBLastAction == 'copy_scopes')
		url = '/Default.aspx?tabId=' + settings.ProjectContainerTabId.toString() + '&cs=' + PJQ.app.session.id + '&v=' + gridITBGroupBy;
	else if (tbITBLastAction == 'add_contacts_from_ab')
		url = '/Default.aspx?tabId=' + settings.AddressBookTabId.toString() + '&ap2=' + PJQ.app.session.id + '&v=' + gridITBGroupBy;
	else if (tbITBLastAction == 'add_contacts_from_ab3')
		url = '/Default.aspx?tabId=' + settings.AddressBookTabId.toString() + '&ap3=' + PJQ.app.session.id + '&v=' + gridITBGroupBy;
	else if (tbITBLastAction == 'add_contacts_from_abpm')
		url = '/Default.aspx?tabId=' + settings.AddressBookTabId.toString() + '&ap2=' + PJQ.app.session.id + '&v=' + gridITBGroupBy + '&newmsg=1';
	else if (tbITBLastAction == 'add_contacts_from_projectpm')
		url = '/Default.aspx?tabId=' + settings.ProjectListTabId.toString() + '&cp2=' + PJQ.app.session.id + '&v=' + gridITBGroupBy + '&newmsg=1';

	window.location.href = url;
}

function GetNewMessageDialogTitle() {
	var pCount = settings.SelectectContactsTemp.length;
	var isPlural = '';
	if (pCount != 1)
		isPlural = 's';

	var windowTitle = 'New Message - <a href="javascript:void(0)" onclick="FilterSelectedOnly()"><u>' + pCount.toString() + ' Recipient' + isPlural + '</u></a>';
	if (pCount == 0)
		windowTitle = 'New Message - ' + pCount.toString() + ' Recipient' + isPlural;

	return windowTitle;
}

function ShowProjectMessageDialog(templateKey) {
	pmTemplateSelected = templateKey;
	GetCheckedRowsITB();
	/*
	var pCount = settings.SelectectContactsTemp.length;
	var isPlural = '';
	if (pCount != 1)
		isPlural = 's';

	 */
	jQuery('#project-message-send').button('option', 'disabled', false);

	jQuery('#project-message-subject').removeClass('pjq-errortext');
	jQuery('label.pjq-errortext', jQuery('#project-message-subject').parent()).remove();
	jQuery('#project-message-quickadd').removeClass('pjq-errortext');
	jQuery('label.pjq-errortext', jQuery('#project-message-quickadd').parent()).remove();
	jQuery('label.pjq-errortext', jQuery('#project-message-body').parent()).remove();
	var bodyframe = null;
	var frames = document.getElementsByTagName("iframe");
	for (i = 0; i < frames.length; i++)
		if (frames[i].className == 'dhxeditor_mainiframe_dhx_web')
			bodyframe = frames[i];

	if (bodyframe) {
		var doc = bodyframe.contentDocument;
		if (doc == undefined || doc == null)
			doc = bodyframe.contentWindow.document;

		doc.body.style.backgroundColor = 'white';
	}
	/*
	var windowTitle = 'New Message - <a href="javascript:void(0)" onclick="FilterSelectedOnly()"><u>' + pCount.toString() + ' Recipient' + isPlural + '</u></a>';
	if (pCount == 0)
		windowTitle = 'New Message - ' + pCount.toString() + ' Recipient' + isPlural;

	 */

	var dlgWidth = 975;
	if (jQuery(document).width() > 1024)
		dlgWidth = jQuery(document).width() * 0.90;

	if (settings.IsPMAttachPrivateOpen)
		PMAttachPF();
	else
		PMDetachPF();

	tempITBSetupNodes = [];
	if (settings.IsEnableITBSetup)
		FindDescendantFieldNodes(0);
	if (settings.IsEnableITBSetup && tempITBSetupNodes.length > 0) {
		jQuery('#project-message-attach-excel,label[for="project-message-attach-excel"]').show();

		if (tvITBSetup && tvITBSetup.getRowsNum() > 0)
			jQuery('#project-message-attach-excel').prop('disabled', false);
		else if (tvITBSetup && tvITBSetup.getRowsNum() == 0)
			jQuery('#project-message-attach-excel').prop('disabled', true);
	}

	dlgPM = jQuery("#project-message-window").dialog({
		modal: true,
		resizable: false,
		title: GetNewMessageDialogTitle(),
		width: dlgWidth,
		buttons: {},
		create: function () {
			$(this).closest('div.ui-dialog')
				.find('.ui-dialog-titlebar-close')
				.click(function (e) {
					PanteraScript.PanteraScriptService.GetNewProjectMessageUploadGuid(PJQ.app.session.id, PMUploadReInitialize, onScriptError);
					e.preventDefault();
				});
		}
	});
	jQuery("#project-message-window").off("dialogclose", PMDialogClosed);
	jQuery("#project-message-window").on("dialogclose", PMDialogClosed);

	jQuery("#project-message-addpart").button()
		.click(function () {
			// add from AB clicked
		}).next()
		.button({
			text: false,
			icons: {
				primary: "ui-icon-triangle-1-s"
			}
		})
		.click(function () {
			var menu = $(this).parent().next().show().position({
				my: "right top",
				at: "right bottom",
				of: this
			});
			$(document).one("click", function () {
				menu.hide();
			});
			return false;
		}).parent().buttonset().next().hide().menu();

	if (!isCreatingMessage) {
		//fileUploadCounter = 0;
		PMUploadInitialize();

		//jQuery("#project-message-files table[role='presentation'] tbody tr").remove();


		if (!(pjqIsIE || (pjqBrowserVersion == 11 && navigator.userAgent.indexOf("rv:11") != -1)))
			jQuery('#project-message-files div.dropnotice').show();

		if (settings.IsFaxEnabled) {
			jQuery('td.pm-send-opt').removeClass('pjq-hidden');
			jQuery('#project-message-send-email-or-fax').prop('checked', false);
			jQuery('#project-message-send-fax').prop('checked', false);
			jQuery('#project-message-send-fax-if-email-fails').prop('checked', false);
			if (PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_MESSAGING_SEND_OPTIONS_FAX_ALWAYS)) {
				jQuery('#project-message-send-fax').prop('checked', true);
			}
			else {
				if (PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_MESSAGING_SEND_OPTIONS_FAX_NO_EMAIL)) {
					jQuery('#project-message-send-email-or-fax').prop('checked', true);
				}
				if (PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_MESSAGING_SEND_OPTIONS_FAX_EMAIL_FAILED)) {
					jQuery('#project-message-send-fax-if-email-fails').prop('checked', true);
				}
			}
		}

		if (pmTemplateSelected)
			jQuery('#project-message-type').val(pmTemplateSelected);
		else
			jQuery('#project-message-type').val(jQuery('#project-message-type :nth-child(1)').val());

		dhtmlx.image_path = "/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxeditor/imgs/";
		if (msgEditor)
			msgEditor.setContent('');
		else {
			msgEditor = new dhtmlXEditor("project-message-body", 'dhx_web');
			msgEditor.init();
			msgEditor.attachEvent("onAccess", function (eventName, e) {
				if (eventName == "keyup" || eventName == 'click') {
					if (tRefreshPreview)
						clearTimeout(tRefreshPreview);

					if (e.ctrlKey && e.keyCode == 86)
						setTimeout(function () {
							msgEditor.setContent(cleanWordPaste(msgEditor.getContent()));
						}, 200);

					tRefreshPreview = setTimeout(function () {
						PMPreview();
					}, 500);

				}
			});
			jQuery(msgEditor.edDoc.body).on('paste', function () {
				setTimeout(function () {
					msgEditor.setContent(cleanWordPaste(msgEditor.getContent()));
					PMPreview();
				}, 400);
			});
			msgEditor.tb.hideItem('applyH1');
			msgEditor.tb.hideItem('applyH2');
			msgEditor.tb.hideItem('applyH3');
			msgEditor.tb.hideItem('applyH4');
			msgEditor.tb.hideItem('separ01');
			msgEditor.tb.hideItem('applySub');
			msgEditor.tb.hideItem('applySuper');
			msgEditor.tb.hideItem('separ04');
			msgEditor.tb.hideItem('increaseIndent');
			msgEditor.tb.hideItem('decreaseIndent');
			msgEditor.tb.hideItem('separ06');

			if (!pjqIsIE || pjqBrowserVersion > 8) {
				msgEditor.tb.addSeparator("font_sep", 27);
				var fontSizes = [
					['fs1', 'obj', '1', ''],
					['fs2', 'obj', '2', ''],
					['fs3', 'obj', '3', ''],
					['fs4', 'obj', '4', ''],
					['fs5', 'obj', '5', ''],
					['fs6', 'obj', '6', ''],
					['fs7', 'obj', '7', '']
				];
				msgEditor.tb.addButtonSelect("font_size", 28, "", fontSizes, 'textSizeIcon-01.png', null);

				var foregroundColors = [
					['fgff0000', 'obj', 'Red', ''],
					['fgff7f00', 'obj', 'Orange', ''],
					['fgffff00', 'obj', 'Yellow', ''],
					['fg00ff00', 'obj', 'Green', ''],
					['fg0000ff', 'obj', 'Blue', ''],
					['fg7f007f', 'obj', 'Purple', ''],
					['fgffffff', 'obj', 'White', ''],
					['fg000000', 'obj', 'Black', '']
				];
				msgEditor.tb.addButtonSelect("foreground_colors", 29, "", foregroundColors, 'textColorIcon-01-01.png', null);

				var backgroundColors = [
					['bgff0000', 'obj', 'Red', ''],
					['bgff7f00', 'obj', 'Orange', ''],
					['bgffff00', 'obj', 'Yellow', ''],
					['bg00ff00', 'obj', 'Green', ''],
					['bg0000ff', 'obj', 'Blue', ''],
					['bg7f007f', 'obj', 'Purple', ''],
					['bgffffff', 'obj', 'White', ''],
					['bg000000', 'obj', 'Black', '']
				];
				msgEditor.tb.addButtonSelect("background_colors", 30, "", backgroundColors, 'backgroundColorIcon-01.png', null);

				msgEditor.tb.addSeparator("tokens_sep", 31);
				msgEditor.tb.addButton("tokens", 32, "Token List", "", "");

				msgEditor.tb.attachEvent("onClick", function (id) {
					if (id.indexOf('fs') !== -1) {
						msgEditor.runCommand('fontSize', id.substr(2));
						msgEditor.setContent(cleanWordPaste(msgEditor.getContent()));
					}
					else if (id.indexOf('fg') !== -1) {
						msgEditor.runCommand('foreColor', id.substr(2));
						msgEditor.setContent(cleanWordPaste(msgEditor.getContent()));
					}
					else if (id.indexOf('bg') !== -1) {
						msgEditor.runCommand('backColor', id.substr(2));
						msgEditor.setContent(cleanWordPaste(msgEditor.getContent()));
					}
					else if (id == 'tokens') {
						jQuery('#message-token-list').removeClass('pjq-hidden');
						jQuery('#message-token-list').css('top', (jQuery('#project-message-window').height() - jQuery('#message-token-list').height()) / 2);
						jQuery('#message-token-list').css('left', (jQuery('#project-message-window').width() - jQuery('#message-token-list').width()) / 2);
					}
				});
			}
		}

		jQuery('#project-message-subject').val('');

		jQuery('#project-message-subject').keyup(function () {
			if (tRefreshPreview)
				clearTimeout(tRefreshPreview);

			tRefreshPreview = setTimeout(function () {
				PMPreview();
			}, 500);
		});

		jQuery('#project-message-preview').val('');
		if (_.size(PJQ.app.session.project.get('bidsDue')) > 0) {
			jQuery('#project-message-response-due').val(PJQ.helpers.dateHelpers.getDateString(new Date(PJQ.app.session.project.get('bidsDue')), PJQ.helpers.dateHelpers.dateFormats.DATE));
		}
		if (jQuery('#project-response-due-asap').prop('checked'))
			jQuery('#project-message-response-due-asap').prop('checked', true);
		else
			jQuery('#project-message-response-due-asap').prop('checked', false);


		if (jQuery("#project-message-files table[role='presentation'] tbody tr").length > 0)
			jQuery('#project-message-files div.dropnotice').hide();

		LoadPMTemplate();
	}
}

function PMDialogClosed(event, ui) {
	tbITB.enableItem("new");
	tbITB.enableItem("add_default");
	let newItbBtn = jQuery('#create-new-itb');
	if (newItbBtn.hasClass('ui-button')) {
		newItbBtn.button('option', 'label', sendNewLabel);
	}
	else {
		newItbBtn.find('.btn-text').text(sendNewLabel);
	}
	if (!isCreatingMessage) {
		settings.IsPMAttachPrivateOpen = false;
		settings.PMPrivateFolderIds = '';
	}

}

function LoadPMTemplate() {
	if (!jQuery('#project-message-type').find('option:selected').attr('disabled')) {
		let mType = jQuery('#project-message-type').val();
		if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.NEW_APP_PORTAL)) {
			new PJQ.ajax.Request({
				url: PJQ.helpers.urlHelpers.buildAPIURL(PJQ.helpers.urlHelpers.generateEndpoint([
					{
						endpoint: 'projects',
						value: PJQ.app.session.project.id
					},
					{
						endpoint: 'projectmessagepreview'
					}
				], [
					{
						parameter: "templateKey",
						value: mType
					}
				]), true, true)
			}).post().done(_.bind(function (result) {
				pmTemplate = result;
				LoadPMTemplateC(pmTemplate);
			}, this)).fail(function () {

			});
		}
		else {
			PanteraScript.PanteraScriptService.GetProjectMessageTemplate(PJQ.app.session.id, PJQ.app.session.project.id, mType, function (response) {
				pmTemplate = jQuery.parseJSON(response);
				LoadPMTemplateC(pmTemplate);
			}, onScriptError);
		}
	}
}

function LoadPMTemplateC(pmTemplate) {
	if (settings.PMTemplate.length > 0) {
		jQuery('#project-message-subject').val(settings.PMSubject);
		jQuery('#project-message-response-type').val(settings.PMResponseType);
		jQuery('#project-message-response-due').val(settings.PMResponseDue);
		jQuery('#project-message-response-due-asap').prop('checked', settings.PMResponseDueASAP);
		jQuery('#project-message-allow-comments').prop('checked', settings.PMAllowPublic);
		jQuery('#project-message-attach-excel').prop('checked', false);

		jQuery('#project-message-send-email-or-fax').prop('checked', false);
		jQuery('#project-message-send-fax').prop('checked', false);
		jQuery('#project-message-send-fax-if-email-fails').prop('checked', false);
		if (PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_MESSAGING_SEND_OPTIONS_FAX_ALWAYS)) {
			jQuery('#project-message-send-fax').prop('checked', true);
		}
		else {
			if (PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_MESSAGING_SEND_OPTIONS_FAX_NO_EMAIL)) {
				jQuery('#project-message-send-email-or-fax').prop('checked', true);
			}
			if (PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_MESSAGING_SEND_OPTIONS_FAX_EMAIL_FAILED)) {
				jQuery('#project-message-send-fax-if-email-fails').prop('checked', true);
			}
		}

		if (settings.PMSendOption.indexOf('ITB_SETUP_EXCEL') != -1) {
			jQuery('#project-message-attach-excel').prop('checked', true);
			jQuery('#project-message-attach-excel').prop('disabled', false);
		}

		jQuery('#project-message-quickadd').val(settings.PMQuickAdd);

		msgEditor.setContent(settings.PMMessage);

		settings.PMTemplate = '';
	}
	else if (pmCopy == null) {
		msgEditor.setContent(pmTemplate.Template.DefaultTextTemplate);
		jQuery('#project-message-response-type').val(pmTemplate.Template.ProjectMessageType);
		jQuery('#project-message-subject').val(pmTemplate.Template.SubjectTemplate);
		jQuery('#project-message-allow-comments').prop('checked', false);
		jQuery('#project-message-attach-excel').prop('checked', false);

	}
	else {
		if (pmCopy.MessageSubject == '' || pmCopy.MessageSubject == 'Project Notification')
			jQuery('#project-message-subject').val(pmTemplate.Template.SubjectTemplate);
		else
			jQuery('#project-message-subject').val(pmCopy.MessageSubject);

		msgEditor.setContent(pmCopy.MessageBody);
		jQuery('#project-message-response-type').val(pmCopy.MessageType);
		jQuery('#project-message-allow-comments').prop('checked', pmCopy.IsAllowPublicComment);
		if (settings.IsFaxEnabled) {
			jQuery('#project-message-send-email-or-fax').prop('checked', false);
			jQuery('#project-message-send-fax').prop('checked', false);
			jQuery('#project-message-send-fax-if-email-fails').prop('checked', false);
			if (PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_MESSAGING_SEND_OPTIONS_FAX_ALWAYS)) {
				jQuery('#project-message-send-fax').prop('checked', true);
			}
			else {
				if (PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_MESSAGING_SEND_OPTIONS_FAX_NO_EMAIL)) {
					jQuery('#project-message-send-email-or-fax').prop('checked', true);
				}
				if (PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_MESSAGING_SEND_OPTIONS_FAX_EMAIL_FAILED)) {
					jQuery('#project-message-send-fax-if-email-fails').prop('checked', true);
				}
			}
		}

		// Load existing files:
		PMUploadRefresh(settings.FileUploadGuid);

		pmCopy = null;
	}
	PMPreview();
}

function PMPreview() {
	tRefreshPreview = null;
	var template = pmTemplate.Template.BodyTemplate;
	pmTemplate.ProjectMessage.MessageBody = cleanWordPaste(msgEditor.getContent());
	pmTemplate.ProjectMessage.ResponseType = 'N/A';
	if (jQuery('#project-message-response-type').val() == 'PROJECT')
		pmTemplate.ProjectMessage.ResponseType = 'ACCEPT/DECLINE';
	else
		pmTemplate.ProjectMessage.ResponseType = 'YES/NO';

	pmTemplate.ProjectMessage.BidDueDate = jQuery('#project-message-response-due').val();
	pmTemplate.ProjectMessage.ResponseDueDate = jQuery('#project-message-response-due').val();

	if (jQuery('#project-message-response-due-asap').prop('checked')) {
		pmTemplate.ProjectMessage.BidDueDate = 'ASAP';
		pmTemplate.ProjectMessage.ResponseDueDate = 'ASAP';
	}

	template = template.replace(/\[ProjectMessage.MessageBody\]/g, "<a id='PMBodyAnchor' />" + pmTemplate.ProjectMessage.MessageBody);

	template = TranslateTokens(template);

	var bodyTemplate = $.templates(template);

	var template2 = jQuery('#project-message-subject').val();

	template2 = TranslateTokens(template2);

	var subjectTemplate = $.templates(template2);

	if (jQuery('#project-message-preview').scrollTop() > 0)
		scrPreview = jQuery('#project-message-preview').scrollTop();

	jQuery('#project-message-spreview').html(subjectTemplate.render(pmTemplate));
	jQuery('#project-message-spreview').attr('title', subjectTemplate.render(pmTemplate));
	jQuery('#project-message-preview').html(bodyTemplate.render(pmTemplate));

	setTimeout(function () {
		if (scrPreview > 0)
			jQuery('#project-message-preview').scrollTop(scrPreview);
	}, 10);
}

function PMUploadInitialize() {
	if (pmUploadInit)
		return;

	if (pjqIsIE || (pjqBrowserVersion == 11 && navigator.userAgent.indexOf("rv:11") != -1)) {
		jQuery('#private-dragdrop-notice').text('Files Attached:');
		jQuery('#project-message-files').css('border', 'solid 1px black');
		jQuery('#project-message-files div.dropnotice').addClass('pjq-hidden');
		jQuery('#project-message-files div.dropnotice').css('display', 'none');

	}
	else
		jQuery('#if-upload-private').addClass('pjq-hidden');

	pmUploadInit = true;
}

function resetITBGridSizes() {
	jQuery('#grid-itb').css('width', '100%');
	jQuery('#grid-toolbar-itb').css('width', '100%');
	jQuery('#grid-paging-itb').css('width', '100.3%');
	jQuery('#grid-paging2-itb').css('width', '100.3%');
	jQuery('#grid-toolbar-itb-search').css('width', '100%');
	if (gridITB) {
		gridITB.enableAutoWidth(false);
		gridITB.callEvent("onGridReconstructed", []);
		gridITB.setSizes();
		gridITB.enableAutoWidth(true);
	}
}

function PJQProjectWallAdminITBInitialize() {
	jQuery('.pjq-group-label').text(settings.GroupLabel);

	dhtmlxEvent(window, "resize", function () {
		resetITBGridSizes();
	});

	tbITB = new dhtmlXToolbarObject("grid-toolbar-itb");
	tbITB.setSkin("dhx_web");
	tbITB.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxToolbar/imgs/");

	tbITBSearch = new dhtmlXToolbarObject("grid-toolbar-itb-search");
	tbITBSearch.setSkin("dhx_web");
	tbITBSearch.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxToolbar/imgs/");

	var newOpts = new Array();
	var i = 0;
	var newOption = '';
	jQuery('#project-message-type option').remove();
	for (i = 0; i < settings.ProjectMessageTemplates.length; i++) {
		newOpts.push(new Array(settings.ProjectMessageTemplates[i].TemplateKey, 'obj', settings.ProjectMessageTemplates[i].TemplateName, ''));
	}

	PMPreInit();

	let newItbBtn = jQuery('#create-new-itb');
	if (settings.IsITBDisabled && !pjqIsNewProject) {

		if (settings.IsDocumentsDisabled)
			jQuery('#tabsMain').tabs('option', 'disabled', [2, 4]);
		else
			jQuery('#tabsMain').tabs('option', 'disabled', [2]);


		if (newItbBtn.hasClass('ui-button')) {
			newItbBtn.button('option', 'disabled', true);
		}
		else {
			newItbBtn.prop('disabled', true);
		}
	}

	if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ITB_SEND_NEW_LABEL))
		sendNewLabel = PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ITB_SEND_NEW_LABEL);

	if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ITB_RESUME_LABEL))
		resumeLabel = PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ITB_RESUME_LABEL);
	if (newItbBtn.hasClass('ui-button')) {
		newItbBtn.button('option', 'label', sendNewLabel);
	}
	else {
		newItbBtn.find('.btn-text').text(sendNewLabel);
	}

	jQuery('#project-status-response option').remove();
	newOption = "<option value='PENDING'>PENDING</option>";
	jQuery('#project-status-response').append(newOption);
	for (i = 0; i < settings.ProjectStatus.length; i++) {
		newOption = "<option value='" + settings.ProjectStatus[i] + "'>" + settings.ProjectStatus[i] + "</option>";
		jQuery('#project-status-response').append(newOption);
	}

	var groupOpts = Array(Array('view_default', 'obj', 'Company', ''), Array('view_message', 'obj', 'Message', ''), Array('view_response', 'obj', 'Response', ''), Array('view_group', 'obj', settings.GroupLabel, ''));

	if (settings.IsProjectScopeEnabled)
		groupOpts.push(Array('view_scope', 'obj', 'Scopes', ''));


	let addOpts = Array(Array('add_contacts_scope', 'obj', 'for Scopes / Radius', ''), Array('add_contacts_from_ab', 'obj', 'from Address Book', ''), Array('add_contacts_from_ab_beta', 'obj', 'from Address Book Beta', ''), Array('add_contacts_from_project', 'obj', 'from Another Project', ''), Array('add_contacts_quick', 'obj', 'Quick Add', ''));
	if (settings.IsEnableITBSetup)
		addOpts = Array(Array('add_contacts_scope', 'obj', 'for Scopes / Radius', ''), Array('add_contacts_from_ab', 'obj', 'from Address Book', ''), Array('add_contacts_from_ab_beta', 'obj', 'from Address Book Beta', ''), Array('add_contacts_from_ab3', 'obj', 'from Address Book w/ AutoSearch', ''), Array('add_contacts_from_project', 'obj', 'from Another Project', ''), Array('add_contacts_quick', 'obj', 'Quick Add', ''));

	if (!PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_SIMPLE_SEARCH)) {
		addOpts.push(Array('add_contacts_simple', 'obj', 'Simple Search', ''));
	}

	tbITB.addButtonSelect("new", 0, "New", newOpts, "new.gif", "new_dis.gif");
	tbITB.setListOptionSelected('new', null);

	tbITB.addSeparator("sep2", 3);
	tbITB.addButtonSelect("add_default", 4, "Add Participants", addOpts, "AddContact.png", "AddContactD.png");
	tbITB.setListOptionSelected("add_default", null);
	tbITB.hideListOption("add_default", "add_contacts_scope");
	tbITB.addSeparator("sep3", 5);
	tbITB.addButton("filter", 6, "Filter", "ico_filtertickets.gif", "");
	tbITB.addSeparator("sep4", 7);
	tbITB.addButtonSelect("view_by", 8, "View By", groupOpts, "group.gif", "");
	tbITB.addSeparator("sep5", 9);
	tbITB.addButtonTwoState("enable_declined", 10, "Enable Declined", "Decline.png", "");
	tbITB.addSeparator("copy_scopes_sep", 9);
	tbITB.addButton("copy_scopes", 10, "Copy Scopes", "Copy.gif", "");
	tbITB.hideItem("copy_scopes_sep");
	tbITB.hideItem("copy_scopes");
	tbITB.addSeparator("set_response_multiple_sep", 19);
	tbITB.addButton("set_response_multiple", 20, "Set Response", "SetResponse.png", "SetResponseD.png");
	tbITB.disableItem("set_response_multiple");
	tbITB.addSeparator("sep6", 21);
	tbITB.addButton("order_prints_multiple", 22, "Order Prints", "Ship.png", "Ship.png");
	tbITB.disableItem("order_prints_multiple");
	tbITB.addSeparator("resend_multiple_sep", 23);
	tbITB.addButton("resend_multiple", 24, "Resend", "Resend2.png", "Resend2D.png");
	tbITB.hideItem("resend_multiple_sep");
	tbITB.hideItem("resend_multiple");
	tbITB.addSeparator("delete_multiple_sep", 25);
	tbITB.addButton("delete_multiple", 26, "Delete", "Delete.png", "DeleteD.png");
	tbITB.disableItem("delete_multiple");
	tbITB.addSeparator("copy_message_sep", 27);
	tbITB.addButton("copy_message", 28, "Copy Message", "copy.gif", "copy_dis.gif");
	tbITB.disableItem("copy_message");
	tbITB.hideItem("copy_message_sep");
	tbITB.hideItem("copy_message");
	tbITB.addSpacer("copy_message");
	tbITB.addSeparator("cancel_add_project_contacts_sep", 29);
	tbITB.addButton("cancel_add_project_contacts", 30, "Back to Project Contacts", "redo.gif", "");
	tbITB.hideItem('cancel_add_project_contacts_sep');
	tbITB.hideItem('cancel_add_project_contacts');

	tbITB.addSeparator("sep_last", 50);

	tbITBSearch.addInput('search_for', 2, '', 400);
	tbITBSearch.addButton("search", 3, "Search/Refresh", "action_search.gif", "");
	tbITBSearch.addSeparator("search_sep", 4);
	tbITBSearch.addButton("clear", 5, "Clear All", "", "");
	tbITBSearch.addSeparator("clear_sep", 6);
	tbITBSearch.addText('info', 7, '');
	tbITBSearch.addSpacer("info");

	tbITBSearch.addSeparator("export_messages_sep", 10);
	tbITBSearch.addButton("export_messages", 11, "Export All", "Excel.jpg", "ExcelD.jpg");
	tbITBSearch.hideItem('export_messages_sep');
	tbITBSearch.hideItem('export_messages');

	tbITBSearch.addSeparator("export_sep", 12);
	tbITBSearch.addButton("export", 13, "Export", "Excel.jpg", "ExcelD.jpg");
	tbITBSearch.addSeparator("add_project_contacts_sep", 14);
	tbITBSearch.addButton("add_project_contacts", 15, "Add Selected Contacts", "AddContact.png", "AddContactD.png");
	tbITBSearch.hideItem('add_project_contacts');
	tbITBSearch.hideItem('add_project_contacts_sep');

	tbITBSearch.attachEvent("onClick", function (id) {
		if (id == 'view_by')
			InitializeGridITB('view_default');
		else if (id == 'refresh' || id == 'search') {
			InitializeGridITB(gridITBGroupBy);
		}
		else if (id == 'clear') {
			GetCheckedRowsITB();
			if (settings.SelectectContactsTemp.length > 0) {
				showInfoDialogPWall('Clear Selections', 'Participants are currently selected.  Do you want to clear these selections?', 'ui-icon-alert', 'clear-search-itb');
			}
			else {
				FilterClearAllClick();
			}
		}
		else if (id == 'export') {
			ShowBusyITB("Exporting...");
			if (gridITBGroupBy == 'view_default')
				PanteraScript.PanteraScriptService.ExportParticipantList(PJQ.app.session.id, ExportPLC, onScriptError);
			else if (gridITBGroupBy == 'view_message') {
				var projectMessageId = gridITB.getSelectedRowId();
				PanteraScript.PanteraScriptService.ExportMessageParticipantList(PJQ.app.session.id, projectMessageId, ExportPLC, onScriptError);
			}
		}
		else if (id == 'export_messages') {
			ShowBusyITB("Exporting...");
			PanteraScript.PanteraScriptService.ExportProjectMessageList(PJQ.app.session.id, ExportPLC, onScriptError);
		}
		else if (id == 'add_project_contacts') {
			GetCheckedRowsITB();
			initAddPCFromITB(false);
		}
	});
	tbITB.attachEvent("onStateChange", function (id, state) {
		if (id == 'enable_declined') {
			enableDeclined = tbITB.getItemState("enable_declined");

			gridITB.forEachRow(function (id2) {
				var sub_grid_obj = gridITB.cells(id2, 0).getSubGrid();
				if (!sub_grid_obj)
					return;

				sub_grid_obj.forEachRow(function (id) {
					if (sub_grid_obj.getUserData(id, 'IsBlacklisted') == 'true')
						if (gridITBGroupBy != 'view_message')
							sub_grid_obj.setRowTextStyle(id, GetRowStyle(sub_grid_obj, id) + 'text-decoration:line-through;');
						else
							sub_grid_obj.setRowTextStyle(id, GetRowStyle(sub_grid_obj, id) + 'text-decoration:line-through;');

					if (jQuery.inArray(id, invalidProjectContacts) !== -1)
						sub_grid_obj.setRowColor(id, "yellow");

					let statusTemp = gridITBGroupBy.startsWith('view_group') ? sub_grid_obj.getUserData(id, 'GroupStatus') : sub_grid_obj.getUserData(id, 'ProjectStatus');
					if (statusTemp === settings.ProjectStatus[1]) {
						if (!enableDeclined)
							sub_grid_obj.cells(id, GetCheckboxColIndex(sub_grid_obj)).setChecked(false);

						sub_grid_obj.cells(id, GetCheckboxColIndex(sub_grid_obj)).setDisabled(!enableDeclined);
					}

				});
			});

			gridITB.forEachRow(function (rowId) {
				if (gridITBGroupBy == 'view_default' && gridITB.getUserData(rowId, 'ProjectStatus') == settings.ProjectStatus[1]) {
					if (gridITBGroupBy == 'view_default') {
						if (!enableDeclined)
							gridITB.cells(rowId, GetCheckboxColIndex(gridITB)).setChecked(false);
						gridITB.cells(rowId, GetCheckboxColIndex(gridITB)).setDisabled(!enableDeclined);

					}
				}
			});

		}
	});
	tbITB.attachEvent("onClick", function (id) {
		tbITB.setListOptionSelected("new", null);
		tbITB.setListOptionSelected("add_default", null);
		tbITBLastAction = id;
		if (id == 'filter') {

			PanteraScript.PanteraScriptService.GetProjectWallAdminParticipantInfo(PJQ.app.session.id, '', gridITBGroupBy.startsWith('view_group'), FilterDialog, onScriptError);
		}
		else if (id == 'set_response_multiple') {

			var contactCount = subgridCheckedRows.split(',').length;
			if (contactCount == 1 && subgridCheckedRows.trim().length == 0)
				contactCount = 0;
			if (contactCount != settings.SelectectContactsTemp.length) {
				showInfoDialogPWall('Filtered Participants', 'There may be participants selected that are not visible in the grid.  Click OK to Set Response or Cancel to abort.', 'ui-icon-alert', 'set_response_multiple');
				return;
			}

			InitializeSetResponseMultiple();
		}
		else if (id == 'view_by')
			InitializeGridITB('view_default');
		else if (id == 'new')
			ShowProjectMessageDialog();
		else if (id.startsWith('ProjectMessage.'))
			ShowProjectMessageDialog(id);
		else if (id.startsWith('view_'))
			InitializeGridITB(id);
		else if (id == 'refresh' || id == 'search')
			InitializeGridITB(gridITBGroupBy);
		else if (id == 'delete_multiple') {
			var contactCount = subgridCheckedRows.split(',').length;
			if (contactCount == 1 && subgridCheckedRows.trim().length == 0)
				contactCount = 0;
			if (contactCount != settings.SelectectContactsTemp.length) {
				showInfoDialogPWall('Filtered Participants', 'There may be participants selected that are not visible in the grid.  Click OK to Delete or Cancel to abort.', 'ui-icon-alert', 'delete-contacts-itb');
			}
			else {
				if (gridITBGroupBy == 'view_group')
					showInfoDialogPWall('Delete Confirmation', 'Are you sure you want to remove ' + contactCount.toString() + ' participant(s) from the selected ' + settings.GroupLabel + '?', 'ui-icon-alert', 'delete-contacts-itb');
				else
					showInfoDialogPWall('Delete Confirmation', 'Are you sure you want to remove ' + contactCount.toString() + ' participant(s) from this project?', 'ui-icon-alert', 'delete-contacts-itb');
			}
		}
		else if (id == 'resend_multiple') {
			var contactCount = subgridCheckedRows.split(',').length;
			if (contactCount == 1 && subgridCheckedRows.trim().length == 0)
				contactCount = 0;
			if (contactCount != settings.SelectectContactsTemp.length)
				showInfoDialogPWall('Filtered Participants', 'There may be participants selected that are not visible in the grid.  Click OK to Resend or Cancel to abort.', 'ui-icon-alert', 'resend-contacts-itb');
			else
				showInfoDialogPWall('Resend Confirmation', 'Are you sure you want to resend ' + contactCount.toString() + ' message(s)?', 'ui-icon-alert', 'resend-contacts-itb');
		}
		else if (id == 'delete_message') {
			var rowId = gridITB.getSelectedRowId();
			var messageName = gridITB.cells(rowId, 1).getValue();
			showInfoDialogPWall('Delete Confirmation', 'Are you sure you want to permanently delete the selected ' + messageName + '?', 'ui-icon-alert', 'delete-message-itb');
		}
		else if (id == 'copy_message') {
			var rowId = gridITB.getSelectedRowId();
			CopyProjectMsg(rowId);
		}
		else if (id == 'order_prints_multiple') {
			PlaceOrderITB();

		}
		else if (id == 'copy_scopes') {
			new PJQ.views.projectScopes.CopyScopesFromProjectModal({
				onCopy: _.bind(function (data) {
					let endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
						{
							endpoint: 'projects',
							value: PJQ.app.session.project.id
						},
						{
							endpoint: 'scopes'
						},
						{
							endpoint: 'copy'
						}
					]);
					new PJQ.ajax.Request({
						endpoint: endpoint,
						data: {
							projectIdSource: data.id
						}
					}).post().done(_.bind(function () {
						InitializeGridITB(gridITBGroupBy);
					}, this)).fail(function () {
					});

				}, this)
			});

			/*
			var quickAddList = jQuery('#project-message-quickadd').val();
			var subject = jQuery('#project-message-subject').val();
			var templateKey = jQuery('#project-message-type').val();
			var responseType = jQuery('#project-message-response-type').val();
			var responseDueDate = jQuery('#project-message-response-due').val();
			var responseDueASAP = false;
			if (jQuery('#project-message-response-due-asap').prop('checked'))
				responseDueASAP = true;
			var isAllowPublic = jQuery('#project-message-allow-comments').prop('checked');
			var sendOptions = "EMAIL";

			if (jQuery('#project-message-send-fax').prop('checked'))
				sendOptions = ',FAX_AND_EMAIL';
			if (jQuery('#project-message-send-email-or-fax').prop('checked'))
				sendOptions = ',EMAIL_OR_FAX';
			if (jQuery('#project-message-send-fax-if-email-fails').prop('checked'))
				sendOptions = ',EMAIL_FAX_FAILS';
			if (jQuery('#project-message-attach-excel').prop('checked'))
				sendOptions += ',ITB_SETUP_EXCEL';
			var message = '';
			if (msgEditor)
				message = cleanWordPaste(msgEditor.getContent());

			PanteraScript.PanteraScriptService.CreateProjectContactTempContext(pjqSessionId, settings.SelectectContactsTemp.join(), quickAddList, subject, message, templateKey, responseType, responseDueDate, responseDueASAP, sendOptions, isAllowPublic, !jQuery('#project-message-private-folders').hasClass('pjq-hidden'), GetCheckedPrivateFolders(), tbITBc, onScriptError);
			*/

		}
		else if (id == 'add_contacts_from_ab' || id == 'add_contacts_from_ab3') {
			var quickAddList = jQuery('#project-message-quickadd').val();
			var subject = jQuery('#project-message-subject').val();
			var templateKey = jQuery('#project-message-type').val();
			var responseType = jQuery('#project-message-response-type').val();
			var responseDueDate = jQuery('#project-message-response-due').val();
			var responseDueASAP = false;
			if (jQuery('#project-message-response-due-asap').prop('checked'))
				responseDueASAP = true;
			var isAllowPublic = jQuery('#project-message-allow-comments').prop('checked');
			var sendOptions = "EMAIL";

			if (jQuery('#project-message-send-fax').prop('checked'))
				sendOptions += ',FAX_AND_EMAIL';
			if (jQuery('#project-message-send-email-or-fax').prop('checked'))
				sendOptions += ',EMAIL_OR_FAX';
			if (jQuery('#project-message-send-fax-if-email-fails').prop('checked'))
				sendOptions += ',EMAIL_FAX_FAILS';
			if (jQuery('#project-message-attach-excel').prop('checked'))
				sendOptions += ',ITB_SETUP_EXCEL';
			var message = '';
			if (msgEditor)
				message = cleanWordPaste(msgEditor.getContent());

			PanteraScript.PanteraScriptService.CreateProjectContactTempContext(pjqSessionId, settings.SelectectContactsTemp.join(), quickAddList, subject, message, templateKey, responseType, responseDueDate, responseDueASAP, sendOptions, isAllowPublic, !jQuery('#project-message-private-folders').hasClass('pjq-hidden'), GetCheckedPrivateFolders(), tbITBc, onScriptError);
		}
		else if (id === 'add_contacts_from_ab_beta') {
			new PJQ.views.projects.AddParticipantsDetailedModal({
				isUseNewAddressBook: true,
				onSave: _.bind(function (selectedC, selectedPC) {
					if (_.size(selectedPC) > 0) {
						settings.SelectectContactsTemp.push(...selectedPC);
					}
					InitializeGridITB(gridITBGroupBy);
				}, this)
			});
		}
		else if (id == 'add_contacts_from_project') {
			PMAddFromAP();
		}
		else if (id == 'add_contacts_simple') {
			let showUnionStatus = true;
			if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.IS_HIDE_UNION_STATUS)) {
				showUnionStatus = !PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.IS_HIDE_UNION_STATUS);
			}

			new PJQ.views.projectParticipants.AddParticipantsModal({
				model: PJQ.app.session.project,
				isDirectoryEnabled: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_DIRECTORY),
				isUnionStatusEnabled: showUnionStatus,
				onSave: _.bind(function (data) {
					$('#project-message-window').closest('.ui-dialog').removeClass('hidden');
					settings.SelectectContactsTemp = settings.SelectectContactsTemp.concat(data);
					InitializeGridITB(gridITBGroupBy);
				}, this)
			});
		}
		else if (id == 'add_contacts_quick') {
			jQuery('#quick-add').val('');
			jQuery('#quick-add').removeClass('pjq-errortext');
			jQuery('label.pjq-errortext', jQuery('#quick-add').parent()).remove();
			var dlg = jQuery("#quick-add-window").dialog({
				modal: true,
				title: 'Quick Add Participants',
				width: 500,
				buttons: {
					"Quick Add": function () {
						jQuery('#quick-add').removeClass('pjq-errortext');
						jQuery('label.pjq-errortext', jQuery('#quick-add').parent()).remove();

						var emails = jQuery('#quick-add').val().replace(';', ',').split(',');

						if (!PJQ.helpers.validators.validateEmail(emails, true).success)
							return;

						var i = 0;
						if (emails.length > 0)
							for (i = emails.length; i >= 0; i--) {
								if (emails[i])
									emails[i] = emails[i].trim();
								if (!emails[i])
									emails.splice(i, 1);
							}
						if (emails.length < 1) {
							jQuery('#quick-add').parent().append("<label for='quick-add' class='pjq-errortext'>Please enter at least one email address.</label>");
							jQuery('#quick-add').addClass('pjq-errortext');
						}
						else {
							PanteraScript.PanteraScriptService.QuickAddParticipants(PJQ.app.session.id, emails.join(), QuickAddC, onScriptError);
							$(this).dialog("close");
						}
					}
				}
			});
			dlg.parent().appendTo($("Form[name='Form']"));
		}
		else if (id == 'add_contacts_scope') {
			jQuery('#scopes-add-radius').val(settings.DefaultScopeRadius.toString());
			var dlg = jQuery("#scopes-add-window").dialog({
				modal: true,
				title: 'Add Participants for Scopes',
				width: 500,
				buttons: {
					"Add for Scopes": function () {
						ShowBusyITB("Searching for Participants...");
						PanteraScript.PanteraScriptService.ScopeAddParticipants(PJQ.app.session.id, parseInt(jQuery('#scopes-add-radius').val()), ScopeAddParticipantsC, onScriptError);
						$(this).dialog("close");
					}
				}
			});
			dlg.parent().appendTo($("Form[name='Form']"));
		}
		else if (id == 'cancel_add_project_contacts') {
			initAddPCFromITB(false);
		}
	});

	if (settings.IsITBDisabled && !pjqIsNewProject) {
		tbITB.disableItem('new');
	}

	jQuery('input.inp').keypress(function (event) {
		if (event.which == 13) {
			event.preventDefault();
			InitializeGridITB(gridITBGroupBy);
		}
	});
	$('.response-due-label').html(PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.MESSAGE_RESPONSE_DUE_LABEL) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.MESSAGE_RESPONSE_DUE_LABEL) : 'Response Due');

	cmITB_NONE = new dhtmlXMenuObject();
	cmITB_NONE.renderAsContextMenu();

	cmITB_G = new dhtmlXMenuObject();
	cmITB_G.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxMenu/imgs/");
	cmITB_G.addNewChild(cmITB_G.topId, 1, "manage_groups", "Manage " + settings.GroupLabel, false, "icon_profile_16px.gif");
	cmITB_G.addNewChild(cmITB_G.topId, 2, "delete_group", "Delete " + settings.GroupLabel, false, "action_delete.gif");
	cmITB_G.renderAsContextMenu();
	cmITB_G.attachEvent("onClick", function (id, zoneId, casState) {
		//if (gridITBGroupBy == 'view_default' || gridITBGroupBy == 'view_group' || gridITBGroupBy == 'view_scope')
		//  subgridCheckedRows = subGridLast.getSelectedRowId();

		subgridCheckedRows = subGridLast.parentGrid.getSelectedRowId();

		if (id == 'delete_group') {
			showInfoDialogPWall('Delete ' + settings.GroupLabel + ' Confirmation', 'Are you sure you want to remove "' + subGridLast.cells(subGridLast.getSelectedRowId(), 0).getValue() + '" from the ' + settings.GroupLabel + ' for this Participant?  Note this will not change the Address Book, only this Project.', 'ui-icon-alert', 'delete-contact-group-itb');
		}
		else if (id == 'manage_groups') {
			ManageContactGroups();
		}
	});


	cmITB_P = new dhtmlXMenuObject();
	cmITB_P.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxMenu/imgs/");
	cmITB_P.addNewChild(cmITB_P.topId, 1, "view_contact", "Contact Details", false, "ico_contact.gif");
	cmITB_P.addNewChild(cmITB_P.topId, 4, "order_prints", "Order Prints", false, "Ship.png");

	if (GetGroupsSubGridColIndex() > -1)
		cmITB_P.addNewChild(cmITB_P.topId, 5, "manage_groups", "Manage " + settings.GroupLabel, false, "icon_profile_16px.gif");

	cmITB_P.addNewChild(cmITB_P.topId, 6, "upload_bid_docs", "Upload Bid Docs", false, "add_page.gif");

	if (settings.IsDirectory) {
		cmITB_P.addNewChild(cmITB_P.topId, 6, "request_prequal", "Request Prequal", false, "resend2.png");
		cmITB_P.addNewChild(cmITB_P.topId, 7, "report_contact", "Report", false, "report.gif");
		cmITB_P.addNewChild(cmITB_P.topId, 8, "copy_directory", "Copy", false, "copy.gif");
	}
	if (settings.IsContactUpdaterEnabled)
		cmITB_P.addNewChild(cmITB_P.topId, 9, "updater", "Send Updater", false, "resend2.png");

	cmITB_P.addNewChild(cmITB_P.topId, 10, "delete_contact", "Delete Contact", false, "action_delete.gif");
	cmITB_P.addNewChild(cmITB_P.topId, 11, "vcard", "Export vCard", false, "ico_contact.gif");
	cmITB_P.addNewChild(cmITB_P.topId, 12, "project_history", "Project History", false, "history.png");

	cmITB_P.renderAsContextMenu();

	cmITB_P.attachEvent("onClick", function (id, zoneId, casState) {
		subgridCheckedRows = '';
		var subgridSelectedContactId = '';

		if (gridITBGroupBy == 'view_default') {
			subgridCheckedRows = gridITB.getSelectedRowId();
		}
		else {
			subgridCheckedRows = gridITB.cells(gridITB.getSelectedRowId(), 0).getSubGrid().getSelectedRowId()
		}

		if (id == 'view_contact')
			EditContact(subgridCheckedRows);
		else if (id == 'order_prints')
			PlaceOrderITB(subgridCheckedRows);
		else if (id == 'delete_contact') {
			var fromWhere = 'Project';
			if (gridITBGroupBy == 'view_message') {
				fromWhere = 'Message';
			}
			else if (gridITBGroupBy == 'view_group') {
				fromWhere = settings.GroupLabel.substring(0, settings.GroupLabel.length - 1);
			}
			showInfoDialogPWall('Delete Confirmation', 'Are you sure you want to remove this participant from the ' + fromWhere + '?', 'ui-icon-alert', 'delete-contact-itb');
		}
		else if (id == 'manage_groups') {
			ManageContactGroups();
		}
		else if (id == 'upload_bid_docs') {
			if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_NEW_UPLOAD_BID_DOCS)) {
				let contactId;
				if (gridITBGroupBy == 'view_default') {
					contactId = gridITB.getUserData(parseInt(subgridCheckedRows), "ContactId");
				}
				else {
					contactId = gridITB.cells(gridITB.getSelectedRowId(), 0).getSubGrid().getUserData(parseInt(subgridCheckedRows), "ContactId")
				}
				new PJQ.views.projects.UploadParticipantBidDocumentsModal({
					contact: new PJQ.models.contacts.Contact({
						contactId: contactId
					}),
					onSave: _.bind(function (response) {
						if (response.status != null) {
							if (gridITBGroupBy === 'view_default') {
								gridITB.cells(gridITB.getSelectedRowId(), GetProjectStatusColIndex()).setValue(response.status);
							}
							else if (gridITBGroupBy === 'view_group') {
								let subgrid = gridITB.cells(gridITB.getSelectedRowId(), 0).getSubGrid();
								subgrid.cells(subgrid.getSelectedRowId(), GetProjectStatusColIndex()).setValue(response.status);
							}
						}
					}, this)
				});
			}
			else {
				UploadBidDocuments();
			}
		}
		else if (id == 'request_prequal') {
			RequestProjectContactPrequalificationHelper(parseInt(subgridCheckedRows));
		}
		else if (id == 'report_contact') {
			let contactId;
			if (gridITBGroupBy == 'view_default') {
				contactId = gridITB.getUserData(parseInt(subgridCheckedRows), "ContactId");
			}
			else if (gridITBGroupBy == 'view_message') {
				gridITB.cells(gridITB.getSelectedRowId(), 0).getSubGrid().forEachRow(_.bind(function (id) {
					if (gridITB.cells(gridITB.getSelectedRowId(), 0).getSubGrid().getUserData(id, 'ProjectContactId') == subgridCheckedRows)
						contactId = gridITB.cells(gridITB.getSelectedRowId(), 0).getSubGrid().getUserData(id, 'ContactId');
				}, this));
			}
			else {
				contactId = gridITB.cells(gridITB.getSelectedRowId(), 0).getSubGrid().getUserData(parseInt(subgridCheckedRows), "ContactId")
			}
			new PJQ.views.contacts.ReportContactModal({
				contactId: parseInt(contactId),
				onReport: function () {
					InitializeGridITB(gridITBGroupBy);
				}
			});
		}
		else if (id == 'copy_directory') {
			var contactId;
			//the contact id is in a subgrid in response and group modes
			//if (gridITBGroupBy !== 'view_response' && gridITBGroupBy !== 'view_group') {
			if (gridITBGroupBy == 'view_default') {
				contactId = gridITB.getUserData(parseInt(subgridCheckedRows), "ContactId");
			}
			else {
				contactId = gridITB.cells(gridITB.getSelectedRowId(), 0).getSubGrid().getUserData(parseInt(subgridCheckedRows), "ContactId")
			}
			copyDirectoryContactItb(contactId);
		}
		else if (id == 'project_history') {
			let contactId;
			//the contact id is in a subgrid in response and group modes
			if (gridITBGroupBy == 'view_default') {
				contactId = gridITB.getUserData(parseInt(subgridCheckedRows), "ContactId");
			}
			else {
				contactId = gridITB.cells(gridITB.getSelectedRowId(), 0).getSubGrid().getUserData(parseInt(subgridCheckedRows), "ContactId")
			}
			if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_NEW_PROJECT_HISTORY)) {
				new PJQ.views.projects.ProjectParticipantHistoryModal({
					project: PJQ.app.session.project.id,
					contactId: contactId
				});
			}
			else {
				new PJQ.ajax.Request({
					endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
						{
							endpoint: 'contacts',
							value: contactId
						},
						{
							endpoint: 'projecthistory'
						},
					]),
					isPascal: true
				}).get().done(_.bind(function (data) {
					GetContactProjectStatusHistoryC(data);
				}, this));
			}
		}
		else if (id == 'updater') {
			//the contact id is in a subgrid in response and group modes
			//if (gridITBGroupBy !== 'view_response' && gridITBGroupBy !== 'view_group') {
			if (gridITBGroupBy == 'view_default') {
				lastContactId = gridITB.getUserData(parseInt(subgridCheckedRows), "ContactId");
			}
			else {
				lastContactId = gridITB.cells(gridITB.getSelectedRowId(), 0).getSubGrid().getUserData(parseInt(subgridCheckedRows), "ContactId")
			}

			showInfoDialogPWall('Send Contact Updater', 'Are you sure you want to send this contact an Update Request?', 'ui-icon-alert', 'contact-updater');
		}
		else if (id == 'vcard') {
			var contactId;
			if (gridITBGroupBy == 'view_default') {
				contactId = gridITB.getUserData(parseInt(subgridCheckedRows), "ContactId");
			}
			else {
				contactId = gridITB.cells(gridITB.getSelectedRowId(), 0).getSubGrid().getUserData(parseInt(subgridCheckedRows), "ContactId")
			}
			GetVCard(contactId);
		}

	});

	cmITB_PM = new dhtmlXMenuObject();
	cmITB_PM.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxMenu/imgs/");
	cmITB_PM.addNewChild(cmITB_PM.topId, 1, "copy_message", "Copy Message", false, "Copy.gif");
	cmITB_PM.addNewChild(cmITB_PM.topId, 4, "delete_message", "Delete Message", false, "Delete.png");
	cmITB_PM.renderAsContextMenu();
	cmITB_PM.attachEvent("onClick", function (id, zoneId, casState) {
		var rowId = gridITB.getSelectedRowId();
		if (id == 'copy_message') {
			CopyProjectMsg(rowId);
		}
		else if (id == 'delete_message') {
			var messageName = gridITB.cells(rowId, 1).getValue();
			showInfoDialogPWall('Delete Confirmation', 'Are you sure you want to permanently delete the selected ' + messageName + '?', 'ui-icon-alert', 'delete-message-itb');
		}
	});

	cmITB_PMR = new dhtmlXMenuObject();
	cmITB_PMR.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxMenu/imgs/");
	cmITB_PMR.addNewChild(cmITB_PMR.topId, 1, "view_contact", "Contact Details", false, "ico_contact.gif");
	cmITB_PMR.addNewChild(cmITB_PMR.topId, 4, "order_prints", "Order Prints", false, "Ship.png");
	cmITB_PMR.addNewChild(cmITB_PMR.topId, 5, "resend_message", "Resend Message", false, "Resend2.png");

	if (settings.IsDirectory) {
		cmITB_PMR.addNewChild(cmITB_P.topId, 7, "report_contact", "Report", false, "report.gif");
	}

	cmITB_PMR.renderAsContextMenu();

	cmITB_PMR.attachEvent("onClick", function (id, zoneId, casState) {
		subgridCheckedRows = gridITB.cells(gridITB.getSelectedRowId(), 0).getSubGrid().getSelectedRowId();
		gridITB.forEachRow(function (id) {
			var subgrid = gridITB.cells(id, 0).getSubGrid();
			if (!subgrid)
				return;
			if (subgrid.doesRowExist(subgridCheckedRows))
				subgridCheckedRows = subgrid.getUserData(subgridCheckedRows, "ProjectContactId");
		});

		if (id == 'view_contact')
			EditContact(subgridCheckedRows);
		else if (id == 'order_prints')
			PlaceOrderITB(subgridCheckedRows);
		else if (id == 'resend_message') {
			subgridCheckedRows = gridITB.cells(gridITB.getSelectedRowId(), 0).getSubGrid().getSelectedRowId()
			showInfoDialogPWall('Resend Confirmation', 'Are you sure you want to resend this message?', 'ui-icon-alert', 'resend-contact-itb');
		}
		else if (id == 'report_contact') {
			let contactId;
			if (gridITBGroupBy == 'view_default') {
				contactId = gridITB.getUserData(parseInt(subgridCheckedRows), "ContactId");
			}
			else if (gridITBGroupBy == 'view_message') {
				gridITB.cells(gridITB.getSelectedRowId(), 0).getSubGrid().forEachRow(_.bind(function (id) {
					if (gridITB.cells(gridITB.getSelectedRowId(), 0).getSubGrid().getUserData(id, 'ProjectContactId') == subgridCheckedRows)
						contactId = gridITB.cells(gridITB.getSelectedRowId(), 0).getSubGrid().getUserData(id, 'ContactId');
				}, this));
			}
			else {
				contactId = gridITB.cells(gridITB.getSelectedRowId(), 0).getSubGrid().getUserData(parseInt(subgridCheckedRows), "ContactId")
			}
			new PJQ.views.contacts.ReportContactModal({
				contactId: contactId,
				onReport: function () {
					InitializeGridITB(gridITBGroupBy);
				}
			});
		}
	});

	cmITB_PMH = new dhtmlXMenuObject();
	cmITB_PMH.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxMenu/imgs/");
	cmITB_PMH.addNewChild(cmITB_PMH.topId, 1, "resend_message", "Resend Message", false, "Resend2.png");
	cmITB_PMH.renderAsContextMenu();
	cmITB_PMH.attachEvent("onClick", function (id, zoneId, casState) {
		subgridCheckedRows = '';
		subgridCheckedRows = zoneId;
		if (zoneId.indexOf('_') != -1)
			subgridCheckedRows = zoneId.substring(0, zoneId.indexOf('_'));

		gridITB.forEachRow(function (id) {
			var subgrid = gridITB.cells(id, 0).getSubGrid();
			if (!subgrid)
				return;
			if (subgrid.doesRowExist(subgridCheckedRows))
				subgridCheckedRows = subgrid.getUserData(subgridCheckedRows, "ProjectMessageContactBroadcastId");
		});

		if (id == 'resend_message')
			showInfoDialogPWall('Resend Confirmation', 'Are you sure you want to resend this message?', 'ui-icon-alert', 'resend-contact-itb');
	});

	cmITB_PMH3 = new dhtmlXMenuObject();
	cmITB_PMH3.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxMenu/imgs/");
	cmITB_PMH3.addNewChild(cmITB_PMH3.topId, 1, "resend_message", "Resend Message", false, "Resend2.png");
	cmITB_PMH3.renderAsContextMenu();
	cmITB_PMH3.attachEvent("onClick", function (id, zoneId, casState) {
		subgridCheckedRows = subGridLast.getUserData(subGridLast.getSelectedRowId(), "ProjectMessageContactBroadcastId");
		if (id == 'resend_message')
			showInfoDialogPWall('Resend Confirmation', 'Are you sure you want to resend this message?', 'ui-icon-alert', 'resend-contact-itb');
	});

	gridITBGroupBy = settings.DefaultITBView;
	var queryString = window.location.search.substring(1);
	var params = queryString.split('&');
	var isNewMsg = false;
	for (var i = 0; i < params.length; i++) {
		if (params[i].startsWith('v=')) {
			gridITBGroupBy = params[i].substring(2);
			jQuery('#tabsMain').tabs('option', 'active', 2);
		}
		else if (params[i].startsWith('newmsg') || window.isNewMsg) {
			ShowProjectMessageDialog(settings.PMTemplate);
			isNewMsg = true;
			window.isNewMsg = null;
		}
	}
	if (!isNewMsg) {
		settings.PMTemplate = '';
		settings.IsPMAttachPrivateOpen = false;
		settings.PMPrivateFolderIds = '';
	}

	if (settings.ITBPagerPosition && settings.ITBPagerPosition == 'top' && !settings.IsEnableSecondPaging)
		jQuery('#grid-container-itb').prepend(jQuery('#grid-paging-itb'));
	jQuery('div.dhx_toolbar_poly_18_dhx_web:contains("Quick Add") table tr.tr_btn:eq(4)').attr('id', 'btn-quickadd');
	//jQuery('table.buttons_cont:eq(1) tr.tr_btn:eq(3)').attr('id', 'btn-quickadd');

	if (typeof PJQProjectWallAdminITBOverride == 'function')
		PJQProjectWallAdminITBOverride();

}

function FilterClearAllClick() {
	tbITBSearch.setValue('search_for', '');
	ClearAllCheckboxes();
	FilterClearAll();
	tbITBSearch.setItemText('info', '');
	jQuery('#grid-toolbar-itb').show();
	tbITBSearch.showItem('export');
	tbITBSearch.showItem('export_sep');

	if (gridITBGroupBy == 'view_message') {
		tbITBSearch.showItem('export_messages_sep');
		tbITBSearch.showItem('export_messages');
	}

	filterSelectedOnly = false;
	InitializeGridITB(gridITBGroupBy);
}

var colorCoded = false;
var selectedContactGroups = [];

function InitializeGridITB(groupBy, callback) {
	if (gridITB)
		GetCheckedRowsITB();

	if (gridITBGroupBy != groupBy)
		FilterClearAll();

	gridITBGroupBy = groupBy;

	gridITB = new dhtmlXGridObject('grid-itb');
	gridITB.setImagePath('/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/'); //path to images required by grid
	gridITB.enableMultiline(settings.IsITBGridMultiline);
	gridITB.setSkin(pjqGridTheme);

	tbITBSearch.hideItem('export_messages_sep');
	tbITBSearch.hideItem('export_messages');

	if (gridITBGroupBy == 'view_default')
		gridITB.enableContextMenu(cmITB_P);
	else if (gridITBGroupBy == 'view_message') {
		gridITB.enableContextMenu(cmITB_PM);
		tbITBSearch.showItem('export_messages_sep');
		tbITBSearch.showItem('export_messages');
	}
	else
		gridITB.disableContextMenu();

	tbITB.setListOptionSelected('view_by', groupBy);

	if (groupBy == 'view_default') {
		jQuery('#grid-paging-itb').removeClass('pjq-hidden');
		jQuery('#grid-paging2-itb').removeClass('pjq-hidden');
		var paging2 = null;
		if (settings.IsEnableSecondPaging)
			paging2 = 'grid-paging2-itb';
		gridITB.enablePaging(true, settings.ParticipantListRowsPerPage, 3, "grid-paging-itb", true, null, paging2);

		gridITB.setPagingSkin("toolbar", 'dhx_web');

		gridITB.attachEvent("onPageChanged", function (ind, fInd, lInd) {
			jQuery(window).scrollTop(0);
			/* R&R COLORIZATION */
			if (project && project.MasterUserId == 76767) {
				ColorCodeRows();
				colorCoded = true;
			}
		});
	}
	else {
		jQuery('#grid-paging-itb').addClass('pjq-hidden');
		jQuery('#grid-paging2-itb').addClass('pjq-hidden');
	}

	jQuery('#grid-itb').css('width', '100%');
	jQuery('#grid-toolbar-itb').css('width', '100%');
	jQuery('#grid-paging-itb').css('width', '100.3%');
	jQuery('#grid-paging2-itb').css('width', '100.3%');
	jQuery('#grid-toolbar-itb-search').css('width', '100%');
	gridITB.enableAutoHeight(true);
	//gridITB.enableAutoWidth(true);

	gridITB.init();

	gridITB.attachEvent("onCheck", function (rId, cInd, state) {
		var i,
			index = -1;
		for (i = 0; i < settings.SelectectContactsTemp.length; i++) {
			if (settings.SelectectContactsTemp[i] == parseInt(rId))
				index = i;
		}

		if (state && index == -1)
			settings.SelectectContactsTemp.push(parseInt(rId));
		else if (!state && index != -1)
			settings.SelectectContactsTemp.splice(index, 1);

		ParticipantToolbarRefresh(state);
	});
	gridITB.attachEvent("onSubRowOpen", function (id, state) { //dhtmlxgrid 2.1+
		gridITB.setSelectedRow(id);
	});

	var currentPage = 1;
	if (gridITB.currentPage)
		currentPage = gridITB.currentPage;

	gridITB.attachEvent("onBeforeContextMenu", function (id, ind, obj) {
		obj.selectRowById(id);
		var isValidRow = false;
		if (id != 0)
			isValidRow = true;
		var isDirectoryContact = (gridITB.getUserData(id, "IsDirectoryContact") === 'true');
		if (isValidRow) {
			if (isDirectoryContact) {
				cmITB_P.showItem('report_contact');
				cmITB_P.showItem('copy_directory');
				if (settings.IsContactUpdaterEnabled)
					cmITB_P.hideItem('updater');
			}
			else {
				cmITB_P.hideItem('report_contact');
				cmITB_P.hideItem('copy_directory');
				if (settings.IsContactUpdaterEnabled)
					cmITB_P.showItem('updater');
			}
			return true;
		}
	});

	gridITB.entBox.onselectstart = function (e) {
		(e || event).cancelBubble = true;
		return true;
	};

	// collect search info from toolbar/dialog
	var searchFor = tbITBSearch.getValue('search_for');
	if (searchFor.length <= 15 && DigitsOnly(searchFor).length == 10)
		searchFor = DigitsOnly(searchFor);

	ssl = GetSearchStatusList();

	searchGroupList = GetGroupFilterList();

	// save current search values before calling LoadXML
	PanteraScript.PanteraScriptService.SetProjectWallAdminSearchParameters(PJQ.app.session.id, searchFor, ssl, searchGroupList, SetITBSearchC, onScriptError);

	gridITB.attachEvent("onBeforeSorting", function (ind, type, direction) {
		gridITBSortOrder = GetColFieldnameByIndex(ind);
		gridITBSortDirection = direction;
		gridITBSortIndex = ind;

		setTimeout(function () {
			ShowBusyITB("Sorting...");
		}, 10);

		if (gridITBGroupBy == 'view_default') {
			gridITB.setSortImgState(true, ind, direction);
			gridITB.currentPage = 1;
			InitializeGridITB(gridITBGroupBy);
			return false;
		}
		if (gridITBGroupBy == 'view_scope' || ind == 2) {
			this.enableStableSorting(true);
			this.sortRows(1, 'grid_sort_scope', 'asc'); // sort grid by the column with prepared values
			this.sortRows(ind, type, direction); // sort grid by the column with prepared values
			this.setSortImgState(true, ind, direction); // set a correct sorting image
			return false; // block default sorting
		}
		return true;
	});
	gridITB.attachEvent("onAfterSorting", function (index, type, direction) {
		setTimeout(function () {
			HideBusy();
		}, 10);
		gridITB.setSizes();
		return true;
	});

	gridITB.attachEvent("onPageChanged", function (ind, fInd, lInd) {
		jQuery("#grid-itb input.contact-bid-amount").inputmask("decimal", {
			allowMinus: false,
			autoUnmask: true
		});
		gridITB.forEachRow(function (rowId) {
			if (gridITB.getUserData(rowId, 'ProjectStatus') == settings.ProjectStatus[1]) {
				if (!enableDeclined)
					gridITB.cells(rowId, GetCheckboxColIndex(gridITB)).setChecked(false);
				gridITB.cells(rowId, GetCheckboxColIndex(gridITB)).setDisabled(!enableDeclined);

			}

			if (gridITB.getUserData(rowId, 'IsBlacklisted') == 'true')
				gridITB.setRowTextStyle(rowId, GetRowStyle(gridITB, rowId) + 'text-decoration:line-through;');
		});
		setTimeout(function () {
			HideBusy();
		}, 10);
	});

	gridITB.attachEvent("onXLS", function (grid_obj) {
		ShowBusyITB("Loading...");
	});
	gridITB.attachEvent("onXLE", function (grid_obj) {

		gridITB.forEachRow(function (id) {
			if (gridITB.getUserData(id, 'IsBlacklisted') == 'true')
				gridITB.setRowTextStyle(id, GetRowStyle(gridITB, id) + 'text-decoration:line-through;');

			if (jQuery.inArray(id, invalidProjectContacts) !== -1)
				gridITB.setRowColor(id, "yellow");

			if (gridITBGroupBy == 'view_default') {
				if (jQuery.inArray(parseInt(id), settings.SelectectContactsTemp) !== -1)
					gridITB.cells(id, GetCheckboxColIndex(gridITB)).setChecked(true);

				if (gridITB.getUserData(id, 'ProjectStatus') == settings.ProjectStatus[1]) {
					if (!enableDeclined)
						gridITB.cells(id, GetCheckboxColIndex(gridITB)).setChecked(false);
					gridITB.cells(id, GetCheckboxColIndex(gridITB)).setDisabled(!enableDeclined);

				}

			}
		});
		setTimeout(function () {
			HideBusy();
			if (project && project.MasterUserId == 76767) {
				ColorCodeRows();
				colorCoded = true;
			}

			if (typeof callback === 'function')
				callback();
		}, 10);

		resetITBGridSizes();
	});


	gridITB.attachEvent("onSubGridCreated", function (sub_grid_obj, rId, rInd) {
		sub_grid_obj.enableAutoHeight(true);
		ClearSubgridRowSelections();
		gridITB.selectRowById(rId);
		sub_grid_obj.attachEvent("onRowSelect", function (rId2) {
			ClearSubgridRowSelections();
			this.setSelectedRow(rId2);
			gridITB.selectRowById(rId);
			return true;
		});
		if (gridITBGroupBy == 'view_message') {
			//tbITB.enableItem('delete_message');
			tbITB.enableItem('copy_message');
		}

		sub_grid_obj.attachEvent("onSubRowOpen", function (id, state) { //dhtmlxgrid 2.1+
			gridITB.selectRowById(rId);
			this.setSelectedRow(id);
		});

		sub_grid_obj.attachEvent("onAfterSorting", function (index, type, direction) {
			setTimeout(function () {
				HideBusy();
			}, 10);
			return true;
		});
		sub_grid_obj.attachEvent("onBeforeSorting", function (ind, type, direction) {
			setTimeout(function () {
				ShowBusyITB("Sorting...");
			}, 10);
			if (gridITBGroupBy == 'view_message' && ind == 4) {
				this.enableStableSorting(true);
				this.sortRows(1, 'grid_sort_company', 'asc'); // sort grid by the column with prepared values
				this.sortRows(ind, type, direction); // sort grid by the column with prepared values
				this.setSortImgState(true, ind, direction); // set a correct sorting image
				return false; // block default sorting
			}
			if ((gridITBGroupBy == 'view_group' && ind == 4) ||
				(gridITBGroupBy == 'view_scope' && ind == 4)) {
				this.enableStableSorting(true);
				this.sortRows(2, 'grid_sort_company', 'asc'); // sort grid by the column with prepared values
				this.sortRows(ind, type, direction); // sort grid by the column with prepared values
				this.setSortImgState(true, ind, direction); // set a correct sorting image
				return false; // block default sorting
			}
			return true;
		});

		sub_grid_obj.attachEvent("onCheck", function (rId, cInd, state) {

			var subgrid;
			if (gridITBGroupBy == 'view_default' && GetGroupsSubGridColIndex() != -1)
				subgrid = gridITB.cells(gridITB.getSelectedRowId(), GetGroupsSubGridColIndex()).getSubGrid();
			else
				subgrid = gridITB.cells(gridITB.getSelectedRowId(), 0).getSubGrid();

			var i,
				index = -1;
			var pc = '';

			if (gridITBGroupBy == 'view_message' || gridITBGroupBy == 'view_default' || gridITBGroupBy == 'view_response')
				pc = subgrid.getUserData(rId, "ProjectContactId");
			else
				pc = rId;

			index = settings.SelectectContactsTemp.indexOf(parseInt(pc));
			if (state && index == -1) {
				settings.SelectectContactsTemp.push(parseInt(pc));
				if (gridITBGroupBy.indexOf('view_group') > -1) {
					selectedContactGroups.push(pc + '|' + subgrid.getUserData(pc, 'GroupId'));
				}
			}
			else if (!state && index != -1)
				settings.SelectectContactsTemp.splice(index, 1);

			ParticipantToolbarRefresh(state);
		});
		sub_grid_obj.enableMultiline(settings.IsITBGridMultiline);

		sub_grid_obj.entBox.onselectstart = function (e) {
			(e || event),
				cancelBubble = true;
			return true;
		};

		if (gridITBGroupBy == 'view_group' ||
			gridITBGroupBy == 'view_response' ||
			gridITBGroupBy == 'view_scope')
			sub_grid_obj.enableContextMenu(cmITB_P);
		else if (gridITBGroupBy == 'view_message')
			sub_grid_obj.enableContextMenu(cmITB_PMR);
		else if (gridITBGroupBy == 'view_default')
			sub_grid_obj.enableContextMenu(cmITB_PMH);
		else
			sub_grid_obj.enableContextMenu(cmITB_NONE);

		sub_grid_obj.attachEvent("onBeforeContextMenu", function (id, ind, obj) {
			gridITB.selectRowById(rId);
			ClearSubgridRowSelections();
			subGridLast = obj;
			obj.selectRowById(id);

			var isDirectoryContact = (sub_grid_obj.getUserData(id, "IsDirectoryContact") === 'true');
			if (isDirectoryContact) {
				cmITB_P.showItem('report_contact');
				cmITB_PMR.showItem('report_contact');
				cmITB_P.showItem('copy_directory');
				if (settings.IsContactUpdaterEnabled)
					cmITB_P.hideItem('updater');
			}
			else {
				cmITB_P.hideItem('report_contact');
				cmITB_PMR.hideItem('report_contact');
				cmITB_P.hideItem('copy_directory');
				if (settings.IsContactUpdaterEnabled)
					cmITB_P.showItem('updater');
			}

			if (gridITBGroupBy == 'view_default')
				id = sub_grid_obj.getUserData(id, "ProjectMessageContactBroadcastId");

			if (id == '0')
				sub_grid_obj.enableContextMenu(cmITB_NONE);
			else {
				if (gridITBGroupBy == 'view_group' ||
					gridITBGroupBy == 'view_response' ||
					gridITBGroupBy == 'view_scope')
					sub_grid_obj.enableContextMenu(cmITB_P);
				else if (gridITBGroupBy == 'view_message')
					sub_grid_obj.enableContextMenu(cmITB_PMR);
				else if (gridITBGroupBy == 'view_default') {

					if (sub_grid_obj.getUserData(null, 'IsGroupsGrid') == "1")
						sub_grid_obj.enableContextMenu(cmITB_G);
					else
						sub_grid_obj.enableContextMenu(cmITB_PMH);

				}
				else
					sub_grid_obj.enableContextMenu(cmITB_NONE);
			}

			return true;
			//return (id != '0');
		});

		sub_grid_obj.attachEvent("onSubGridCreated", function (sub_grid_obj2, rId2, rInd2) {
			ClearSubgridRowSelections();
			sub_grid_obj2.parentGrid.setSelectedRow(rId2);
			var gid = sub_grid_obj2.parentGrid.getUserData(rId2, "GroupId");
			gridITB.setSelectedRow(gid);
			sub_grid_obj2.enableAutoHeight(true);
			sub_grid_obj2.enableMultiline(true);
			sub_grid_obj2.entBox.onselectstart = function (e) {
				(e || event),
					cancelBubble = true;
				return true;
			};

			sub_grid_obj2.enableContextMenu(cmITB_PMH3);

			sub_grid_obj2.attachEvent("onBeforeContextMenu", function (id, ind, obj) {
				ClearSubgridRowSelections();
				subGridLast = obj;
				var pcgid = obj.getUserData(id, "ProjectContactId");
				var gid = obj.parentGrid.getUserData(pcgid, "GroupId");
				obj.parentGrid.setSelectedRow(pcgid);
				obj.parentGrid.parentGrid.setSelectedRow(gid);
				obj.setSelectedRow(id);

				id = obj.getUserData(id, "ProjectMessageContactBroadcastId");

				if (obj.getUserData(null, 'IsGroupsGrid') == "1")
					obj.enableContextMenu(cmITB_G);
				else if (id == '0')
					obj.enableContextMenu(cmITB_NONE);
				else
					obj.enableContextMenu(cmITB_PMH3);

				return true;
				//return (id != '0');
			});

			sub_grid_obj2.attachEvent("onRowSelect", function (rId) {
				ClearSubgridRowSelections();
				var pcgid = this.getUserData(rId, "ProjectContactId");
				var gid = this.parentGrid.getUserData(pcgid, "GroupId");
				this.setSelectedRow(rId);
				this.parentGrid.setSelectedRow(pcgid);
				this.parentGrid.parentGrid.setSelectedRow(gid);
				return true;
			})

			return true;
		});
		sub_grid_obj.attachEvent("onSubGridLoaded", function (sub_grid_obj2, rId, rInd) {
			sub_grid_obj2.setSizes();
			sub_grid_obj2.callEvent("onGridReconstructed", []);
			gridITB.setSizes();
			//gridITB.callEvent("onGridReconstructed", []);
		});

		sub_grid_obj.attachEvent("onXLE", function (grid_obj) {
			grid_obj.setSizes();
			grid_obj.callEvent("onGridReconstructed", []);
			gridITB.setSizes();

			grid_obj.forEachRow(function (id) {
				if (grid_obj.getUserData(id, 'IsBlacklisted') == 'true')
					if (gridITBGroupBy != 'view_message')
						grid_obj.setRowTextStyle(id, GetRowStyle(grid_obj, id) + 'text-decoration:line-through;');
					else
						grid_obj.setRowTextStyle(id, GetRowStyle(grid_obj, id) + 'text-decoration:line-through;');

				if (jQuery.inArray(id, invalidProjectContacts) !== -1)
					grid_obj.setRowColor(id, "yellow");

				let statusTemp = gridITBGroupBy.startsWith('view_group') ? grid_obj.getUserData(id, 'GroupStatus') : grid_obj.getUserData(id, 'ProjectStatus');
				if (statusTemp === settings.ProjectStatus[1]) {
					if (!enableDeclined)
						grid_obj.cells(id, GetCheckboxColIndex(grid_obj)).setChecked(false);

					grid_obj.cells(id, GetCheckboxColIndex(grid_obj)).setDisabled(!enableDeclined);
				}

			});

			if (gridITBGroupBy.startsWith('view_group') && PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_WALL_SORT_GROUPS_BY_RESPONSE)) {
				grid_obj.sortRows(GetProjectStatusColIndex(), 'grid_sort_selectoption');
			}
			//gridITB.callEvent("onGridReconstructed", []);
		});


		setTimeout(function () {
			ShowBusyITB("Loading...");
		}, 10);
		return true;
	});

	gridITB.attachEvent("onSubRowOpen", function (id, state) {
		if (!state) {
			gridITB.setSizes();
			gridITB.callEvent("onGridReconstructed", []);
		}
	});

	gridITB.attachEvent("onSubGridLoaded", function (sub_grid_obj, rId, rInd) {
		setTimeout(function () {
			HideBusy();
		}, 10);

		/* R&R CUSTOMIZATION */
		if (project && project.MasterUserId == 76767)
			ColorCodeRows();

		sub_grid_obj.forEachRow(function (id) {
			if (sub_grid_obj.getUserData(id, 'IsBlacklisted') == 'true')
				if (gridITBGroupBy != 'view_message')
					sub_grid_obj.setRowTextStyle(id, GetRowStyle(sub_grid_obj, id) + 'text-decoration:line-through;');
				else
					sub_grid_obj.setRowTextStyle(id, GetRowStyle(sub_grid_obj, id) + 'text-decoration:line-through;');

			if (jQuery.inArray(id, invalidProjectContacts) !== -1)
				sub_grid_obj.setRowColor(id, "yellow");

			let statusTemp = gridITBGroupBy.startsWith('view_group') ? sub_grid_obj.getUserData(id, 'GroupStatus') : sub_grid_obj.getUserData(id, 'ProjectStatus');
			if (statusTemp === settings.ProjectStatus[1]) {
				if (!enableDeclined)
					sub_grid_obj.cells(id, GetCheckboxColIndex(sub_grid_obj)).setChecked(false);

				sub_grid_obj.cells(id, GetCheckboxColIndex(sub_grid_obj)).setDisabled(!enableDeclined);
			}

		});

		if (gridITBGroupBy != 'view_default') {
			gridITB.forEachRow(function (rowId) {
				if (gridITB.getUserData(rowId, 'ProjectStatus') == settings.ProjectStatus[1]) {
					subgridCheckedRows = rowId;
					gridITB.forEachRow(function (id) {
						var subgrid = gridITB.cells(id, 0).getSubGrid();
						if (!subgrid)
							return;

						if (subgrid.doesRowExist(subgridCheckedRows)) {
							if (!enableDeclined)
								subgrid.cells(subgridCheckedRows, GetCheckboxColIndex(subgrid)).setChecked(false);
							subgrid.cells(subgridCheckedRows, GetCheckboxColIndex(subgrid)).setDisabled(!enableDeclined);
						}

					});
				}
			});

			var i = 0;
			for (i = 0; i < settings.SelectectContactsTemp.length; i++) {
				if (gridITBGroupBy == 'view_message') {
					sub_grid_obj.forEachRow(function (id) {
						var pc = sub_grid_obj.getUserData(id, "ProjectContactId");
						if (parseInt(pc) == settings.SelectectContactsTemp[i])
							sub_grid_obj.cells(id, GetCheckboxColIndex(sub_grid_obj)).setChecked(true);
					});
				}
				else {
					if (sub_grid_obj.doesRowExist(settings.SelectectContactsTemp[i].toString())) {
						sub_grid_obj.cells(settings.SelectectContactsTemp[i], GetCheckboxColIndex(sub_grid_obj)).setChecked(true);
					}
					/*
					if (sub_grid_obj.doesRowExist(settings.SelectectContactsTemp[i].toString())) {
						if (gridITBGroupBy.indexOf('view_group') == -1 || selectedContactGroups.indexOf(settings.SelectectContactsTemp[i] + '|' + rId) != -1) {
							sub_grid_obj.cells(settings.SelectectContactsTemp[i], GetCheckboxColIndex(sub_grid_obj)).setChecked(true);
						}
					}
					*/
				}
			}
		}

		sub_grid_obj.setSizes();
		sub_grid_obj.callEvent("onGridReconstructed", []);
		return true;
	});

	gridITB.attachEvent("onRowSelect", function (id, ind) {
		ParticipantToolbarRefresh();
	});

}

function SetITBSearchC() {
	var currentPage = 1;

	var groupBy = gridITBGroupBy;
	if (project && project.MasterUserId == 97410 && groupBy == 'view_group')
		groupBy = 'view_group_columns';

	var xmlfile = '/DesktopModules/PJQProjectWallAdmin/GetParticipants.aspx?sessionid=' + PJQ.app.session.id + '&view=' + groupBy + '&pn=' + currentPage.toString() + '&ps=' + settings.ParticipantListRowsPerPage.toString();

	if (gridITBGroupBy == 'view_default') {
		xmlfile += '&o=' + gridITBSortOrder;
		xmlfile += '&d=' + gridITBSortDirection;
	}

	if (filterSelectedOnly)
		xmlfile += '&so=1';

	xmlfile += '&x=' + (new Date).getTime();
	gridITB.loadXML(xmlfile, function () {
		//firefox scroll bug
		if (typeof preReloadGridScrollPosition !== 'undefined') { //it might be, if we are not in firefox, or if this function is being called in a different way/context
			let $newModule = $('.nav-content');
			if (_.size($newModule) > 0 && typeof $newModule[0].scrollTo === 'function') {
				$newModule[0].scrollTo(0, preReloadGridScrollPosition)
			}
			else {
				window.scrollTo(0, preReloadGridScrollPosition);
			}
		}
		if (gridITBGroupBy == 'view_default')
			gridITB.setSortImgState(true, gridITBSortIndex, gridITBSortDirection);

		enableDeclined = tbITB.getItemState("enable_declined");

		// by default, hide the "unsent" notification
		jQuery('#grid-toolbar-itb-unsent').hide();
		var unsentCount = parseInt(gridITB.getUserData(null, 'UnsentCount'));
		if ((unsentCount > 0) && (gridITBGroupBy != 'view_message')) {
			jQuery('#grid-toolbar-itb-unsent').html("<p style='padding-left: 4px;'><span class='ui-icon ui-icon-alert'></span><strong>Note:</strong>&nbsp;<a href='javascript:void(0)' style='text-decoration: underline;' onclick='FilterUnsent()'>There are " + unsentCount.toString() + " Participants that have not been sent a message.  Click here to filter them.</a></p>");
			jQuery('#grid-toolbar-itb-unsent').show();
		}

		gridITB.forEachRow(function (id) {
			if (gridITB.getUserData(id, 'IsBlacklisted') == 'true')
				gridITB.setRowTextStyle(id, GetRowStyle(gridITB, id) + 'text-decoration:line-through;');
		});

		if (project && project.MasterUserId == 76767)
			setTimeout(function () {
				ColorCodeRows();
			}, 10);

		HideBusy();

		if (gridITBGroupBy == 'view_default') {
			jQuery('#filter-broadcast-status td').addClass('pjq-hidden');
			jQuery('#filter-response-status td').removeClass('pjq-hidden');
			jQuery('#filter-group td').removeClass('pjq-hidden');
			if (!isAddProjectContactsContext) {
				tbITB.hideItem("resend_multiple_sep");
				tbITB.hideItem("resend_multiple");
				tbITB.hideListOption("add_default", "add_contacts_scope");
				tbITB.showItem("delete_multiple_sep");
				tbITB.showItem("delete_multiple");
				tbITB.hideItem("copy_message_sep");
				tbITB.hideItem("copy_message");
				tbITB.showItem("set_response_multiple_sep");
				tbITB.showItem("set_response_multiple");
				tbITB.enableItem("add_default");
				tbITB.hideItem("copy_scopes_sep");
				tbITB.hideItem("copy_scopes");

				if (!filterSelectedOnly) {
					tbITBSearch.showItem("export_sep");
					tbITBSearch.showItem("export");
					tbITBSearch.enableItem("export");
				}
			}

			//gridITB.setSortImgState(true, 2, 'asc'); // set a correct sorting image
			jQuery("#grid-itb input.contact-bid-amount").inputmask("decimal", {
				allowMinus: false,
				autoUnmask: true
			});

			gridITB.forEachRow(function (rowId) {
				if (gridITB.getUserData(rowId, 'ProjectStatus') == settings.ProjectStatus[1]) {
					if (!enableDeclined)
						gridITB.cells(rowId, GetCheckboxColIndex(gridITB)).setChecked(false);
					gridITB.cells(rowId, GetCheckboxColIndex(gridITB)).setDisabled(!enableDeclined);

				}
			});

			var i = 0;
			for (i = 0; i < settings.SelectectContactsTemp.length; i++) {
				if (gridITB.doesRowExist(settings.SelectectContactsTemp[i].toString())) {
					gridITB.cells(settings.SelectectContactsTemp[i], GetCheckboxColIndex(gridITB)).setChecked(true);
				}
			}

		}
		else if (gridITBGroupBy == 'view_group') {
			jQuery('#filter-broadcast-status td').addClass('pjq-hidden');
			jQuery('#filter-response-status td').removeClass('pjq-hidden');
			jQuery('#filter-group td').removeClass('pjq-hidden');

			if (!isAddProjectContactsContext) {
				tbITB.hideItem("resend_multiple_sep");
				tbITB.hideItem("resend_multiple");
				tbITB.hideListOption("add_default", "add_contacts_scope");
				tbITB.showItem("delete_multiple_sep");
				tbITB.showItem("delete_multiple");
				//tbITB.hideItem("delete_message_sep");
				//tbITB.hideItem("delete_message");
				tbITB.hideItem("copy_message_sep");
				tbITB.hideItem("copy_message");
				tbITB.showItem("set_response_multiple_sep");
				tbITB.showItem("set_response_multiple");
				tbITB.enableItem("add_default");
				tbITB.hideItem("copy_scopes_sep");
				tbITB.hideItem("copy_scopes");
				tbITBSearch.hideItem("export_sep");
				tbITBSearch.hideItem("export");
				tbITBSearch.hideItem('export_messages_sep');
				tbITBSearch.hideItem('export_messages');
			}
			gridITB.setSortImgState(true, 1, 'asc'); // set a correct sorting image
		}
		else if (gridITBGroupBy == 'view_response') {
			jQuery('#filter-broadcast-status td').addClass('pjq-hidden');
			jQuery('#filter-response-status td').removeClass('pjq-hidden');
			jQuery('#filter-group td').removeClass('pjq-hidden');
			if (!isAddProjectContactsContext) {
				tbITB.hideItem("resend_multiple_sep");
				tbITB.hideItem("resend_multiple");
				tbITB.hideListOption("add_default", "add_contacts_scope");
				tbITB.showItem("delete_multiple_sep");
				tbITB.showItem("delete_multiple");
				//tbITB.hideItem("delete_message_sep");
				//tbITB.hideItem("delete_message");
				tbITB.hideItem("copy_message_sep");
				tbITB.hideItem("copy_message");
				tbITB.showItem("set_response_multiple_sep");
				tbITB.showItem("set_response_multiple");
				tbITB.disableItem("add_default");
				tbITB.hideItem("copy_scopes_sep");
				tbITB.hideItem("copy_scopes");
				tbITBSearch.hideItem("export_sep");
				tbITBSearch.hideItem("export");
				tbITBSearch.hideItem('export_messages_sep');
				tbITBSearch.hideItem('export_messages');
			}
			gridITB.setSortImgState(true, 1, 'asc'); // set a correct sorting image
		}
		else if (gridITBGroupBy == 'view_message') {
			jQuery('#filter-broadcast-status td').removeClass('pjq-hidden');
			jQuery('#filter-response-status td').addClass('pjq-hidden');
			jQuery('#filter-group td').removeClass('pjq-hidden');
			if (!isAddProjectContactsContext) {
				tbITB.showItem("resend_multiple_sep");
				tbITB.showItem("resend_multiple");
				tbITB.disableItem("resend_multiple");
				tbITB.hideListOption("add_default", "add_contacts_scope");
				tbITB.hideItem("delete_multiple_sep");
				tbITB.hideItem("delete_multiple");
				//tbITB.showItem("delete_message_sep");
				//tbITB.showItem("delete_message");
				//tbITB.disableItem('delete_message');
				tbITB.showItem("copy_message_sep");
				tbITB.showItem("copy_message");
				tbITB.disableItem("copy_message");
				tbITB.hideItem("set_response_multiple_sep");
				tbITB.hideItem("set_response_multiple");
				tbITB.disableItem("add_default");
				tbITB.hideItem("copy_scopes_sep");
				tbITB.hideItem("copy_scopes");
				tbITBSearch.showItem("export_sep");
				tbITBSearch.showItem("export");
				tbITBSearch.showItem('export_messages_sep');
				tbITBSearch.showItem('export_messages');
				tbITBSearch.disableItem("export");
				tbITBSearch.disableItem("export_messages");
			}
			gridITB.setSortImgState(true, 8, 'desc'); // set a correct sorting image
			if (selectedProjectMessageId) {
				gridITB.selectRowById(selectedProjectMessageId);
				var cell = gridITB.cells(selectedProjectMessageId, 0);
				cell.open();
				selectedProjectMessageId = '';
				jQuery(window).scrollTop(jQuery(cell.cell).offset().top);
			}
		}
		else if (gridITBGroupBy == 'view_scope') {
			jQuery('#filter-broadcast-status td').addClass('pjq-hidden');
			jQuery('#filter-response-status td').removeClass('pjq-hidden');
			jQuery('#filter-group td').addClass('pjq-hidden');
			if (!isAddProjectContactsContext) {
				tbITB.hideItem("resend_multiple_sep");
				tbITB.hideItem("resend_multiple");
				tbITB.showListOption("add_default", "add_contacts_scope");
				tbITB.showItem("delete_multiple_sep");
				tbITB.showItem("delete_multiple");
				//tbITB.hideItem("delete_message_sep");
				//tbITB.hideItem("delete_message");
				tbITB.hideItem("copy_message_sep");
				tbITB.hideItem("copy_message");
				tbITB.showItem("set_response_multiple_sep");
				tbITB.showItem("set_response_multiple");
				tbITB.enableItem("add_default");
				tbITB.showItem("copy_scopes_sep");
				tbITB.showItem("copy_scopes");
				tbITBSearch.hideItem("export_sep");
				tbITBSearch.hideItem("export");
				tbITBSearch.hideItem('export_messages_sep');
				tbITBSearch.hideItem('export_messages');
			}
		}

		if (isCreatingMessage) {
			tbITB.disableItem("add_default");
		}

		if (gridITBGroupBy != 'view_default') {
			var toggleExpand = "";
			var contactCount = 0;
			for (var i = 0; i < gridITB.getRowsNum(); i++) {
				contactCount += parseInt(gridITB.cells2(i, 3).getValue());
			}
			if (contactCount < 1000)
				toggleExpand += "<a id='grid-itb-expand-all' href='javascript:void(0)' onclick='ITBExpandAll();'><img src='/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/plus.gif'/></a><a href='javascript:void(0)' style='display:none;' onclick='ITBExpandAll();' id='grid-itb-collapse-all'><img src='/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/minus.gif'/></a>"
			if (gridITBGroupBy == 'view_group')
				toggleExpand += "&nbsp;<input type='checkbox' id='groups-select-all' onclick='GroupSelectAll();'>";

			jQuery('div table tbody tr td div.hdrcell', '#grid-itb').first().html(toggleExpand);
		}

		gridITB.setSizes();
		ParticipantToolbarRefresh();
	});
}

function GroupSelectAll() {
	if (jQuery('#groups-select-all').prop('checked')) {
		ShowBusy('Loading...');

		var getProjectContactsURL = "/DesktopModules/PJQProjectWallAdmin/GetProjectContacts.aspx?sessionId=" + PJQ.app.session.id + "&x=" + (new Date).getTime();
		if (enableDeclined)
			getProjectContactsURL += "&ed=1";

		$.getJSON(getProjectContactsURL, function (data) {
			var j = 0;
			for (j = 0; j < data.d.ProjectContacts.length; j++) {
				var i,
					index = -1;
				for (i = 0; i < settings.SelectectContactsTemp.length; i++) {
					if (settings.SelectectContactsTemp[i] == data.d.ProjectContacts[j])
						index = i;
				}

				if (index == -1)
					settings.SelectectContactsTemp.push(data.d.ProjectContacts[j]);

			}
			gridITB.forEachRow(function (rId) {
				var subgrid = gridITB.cells(rId, 0).getSubGrid();
				if (subgrid) {
					SubGridCheckHelper(subgrid, GetCheckboxColIndex(subgrid), true);
				}
			});
			HideBusy();
			if (settings.SelectectContactsTemp.length > 0 || settings.SelectectContactGroupsTemp.length > 0) {
				tbITB.enableItem("set_response_multiple");
				tbITB.enableItem("resend_multiple");
				tbITB.enableItem("delete_multiple");
				tbITB.enableItem("order_prints_multiple");
			}
			else {
				tbITB.disableItem("set_response_multiple");
				tbITB.disableItem("resend_multiple");
				tbITB.disableItem("delete_multiple");
				tbITB.disableItem("order_prints_multiple");
			}

		});
	}
	else {
		ClearAllCheckboxes();
		tbITB.disableItem("set_response_multiple");
		tbITB.disableItem("resend_multiple");
		tbITB.disableItem("delete_multiple");
		tbITB.disableItem("order_prints_multiple");
	}
}

function SubGridCheckHelper(subgrid, col, state) {
	if (!subgrid)
		return;

	if (gridITBGroupBy == 'view_default') {
		subgrid.forEachRow(function (rId2) {
			if ((subgrid.getUserData(rId2, 'GroupStatus') != settings.ProjectStatus[1] && !subgrid.cells(rId2, col).isDisabled()) || enableDeclined)
				subgrid.cells(rId2, col).setChecked(state);
		});
	}
	else {
		subgrid.forEachRow(function (rId2) {
			if ((subgrid.getUserData(rId2, 'ProjectStatus') != settings.ProjectStatus[1] && !subgrid.cells(rId2, col).isDisabled()) || enableDeclined)
				subgrid.cells(rId2, col).setChecked(state);
		});
	}
}

function ITBExpandAll() {
	if (jQuery('#grid-itb-expand-all').is(":visible")) {
		jQuery('#grid-itb-expand-all').hide();
		jQuery('#grid-itb-collapse-all').show();
		gridITB.forEachRow(function (rId) {
			gridITB.cells(rId, 0).open();
		});

	}
	else {
		jQuery('#grid-itb-expand-all').show();
		jQuery('#grid-itb-collapse-all').hide();
		gridITB.forEachRow(function (rId) {
			gridITB.cells(rId, 0).close();
		});
	}
}

function ITBInitializeToolbar() {
	PanteraScript.PanteraScriptService.GetProjectWallAdminParticipantInfo(PJQ.app.session.id, '', gridITBGroupBy.startsWith('view_group'), GetParticipantInfoC, onScriptError);
}

function ParticipantToolbarRefresh() {
	GetCheckedRowsITB();
	if (subgridCheckedRows || settings.SelectectContactsTemp.length > 0) {
		tbITB.enableItem("set_response_multiple");
		tbITB.enableItem("resend_multiple");
		tbITB.enableItem("delete_multiple");
		tbITB.enableItem("order_prints_multiple");
	}
	else {
		tbITB.disableItem("set_response_multiple");
		tbITB.disableItem("resend_multiple");
		tbITB.disableItem("delete_multiple");
		tbITB.disableItem("order_prints_multiple");
	}

	if (gridITBGroupBy == 'view_message') {
		var rowId = gridITB.getSelectedRowId();
		if (rowId) {
			//tbITB.enableItem('delete_message');
			tbITB.enableItem('copy_message');
			tbITBSearch.enableItem("export");
		}
		else {
			//tbITB.disableItem('delete_message');
			tbITB.disableItem('copy_message');
			tbITBSearch.disableItem("export");
		}
		tbITBSearch.enableItem("export_messages");
	}
}

function ParticipantListSelectAll(sender) {
	if (jQuery(sender).prop('checked')) {
		// todo: globally track that all are checked.
		gridITB.checkAll(true);
	}
	else {
		gridITB.checkAll(false);
	}
	ParticipantToolbarRefresh();
}

function ExportPLC(response) {
	HideBusy("Exporting...");
	showInfoDialogPWall('Export Complete', '<a href="' + response + '">Click here to download your export.</a>', 'ui-icon-info');
}

function ProjectStatusChange(sender, projectContactId) {
	statusChange = jQuery(sender).val();
	lastProjectContactId = projectContactId.toString();

	var groupCount = 0;
	if (gridITBGroupBy == 'view_default') {
		if (gridITB.getUserData(projectContactId, 'GroupIdList'))
			groupCount = gridITB.getUserData(projectContactId, 'GroupIdList').split(',').length;
	}
	else {
		gridITB.forEachRow(function (id) {
			var subgrid = gridITB.cells(id, 0).getSubGrid();
			if (subgrid) {
				if (subgrid.doesRowExist(projectContactId)) {
					if (subgrid.getUserData(projectContactId, 'GroupIdList'))
						groupCount = subgrid.getUserData(projectContactId, 'GroupIdList').split(',').length;
				}
			}
		});
	}

	if (!settings.IsPerGroupDisabled && groupCount > 1)
		showInfoDialogPWall('Confirm Status Change', 'Are you sure you want to change the status for all ' + settings.GroupLabel + ' for this Participant?', 'ui-icon-alert', 'project-status-change');
	else
		ProjectStatusChangeFinal();
}

function ProjectStatusChangeFinal() {
	var callback = null;
	var subgrid = null;

	PanteraScript.PanteraScriptService.SetProjectContactStatusAndNotes(PJQ.app.session.id, parseInt(lastProjectContactId), decodeURIComponent(statusChange), '', function () {

		if (GetGroupsSubGridColIndex() > -1) {
			if (gridITBGroupBy == 'view_default') {
				if (gridITB.getUserData(gridITB.getSelectedRowId(), '__sub_row_last') == GetGroupsSubGridColIndex()) {
					subgrid = gridITB.cells(gridITB.getSelectedRowId(), GetGroupsSubGridColIndex()).getSubGrid();
					var wasOpen = false;
					if (gridITB.cells(gridITB.getSelectedRowId(), GetGroupsSubGridColIndex()).isOpen()) {
						gridITB.cells(gridITB.getSelectedRowId(), GetGroupsSubGridColIndex()).close();
						wasOpen = true;
					}

					var url = subgrid.xmlFileUrl + '&x' + (new Date).getTime().toString() + '=1';
					subgrid.clearAll();
					subgrid.loadXML(url, function () {
						subgrid.setSizes();
						subgrid.callEvent("onGridReconstructed", []);
						gridITB.setSizes();
					});

					if (wasOpen)
						gridITB.cells(gridITB.getSelectedRowId(), GetGroupsSubGridColIndex()).open();
				}
			}
			else if (gridITBGroupBy == 'view_group' || gridITBGroupBy == 'view_scope') {
				gridITB.forEachRow(function (id) {
					var subgrid = gridITB.cells(id, 0).getSubGrid();
					if (subgrid) {
						if (subgrid.doesRowExist(lastProjectContactId)) {
							if (subgrid.getUserData(lastProjectContactId, '__sub_row_last') == GetGroupsSubGridColIndex()) {
								var subgrid2 = subgrid.cells(lastProjectContactId, GetGroupsSubGridColIndex()).getSubGrid();
								var wasOpen = false;
								if (subgrid.cells(lastProjectContactId, GetGroupsSubGridColIndex()).isOpen()) {
									subgrid.cells(lastProjectContactId, GetGroupsSubGridColIndex()).close();
									wasOpen = true;
								}

								var url = subgrid2.xmlFileUrl + '&x' + (new Date).getTime().toString() + '=1';
								subgrid2.clearAll();
								subgrid2.loadXML(url, function () {
									subgrid.setSizes();
									subgrid.callEvent("onGridReconstructed", []);
									subgrid.setSizes();
								});

								if (wasOpen)
									subgrid.cells(lastProjectContactId, GetGroupsSubGridColIndex()).open();
							}

						}
					}
				});

			}
		}

	}, onScriptError);

	var isDeclined = (statusChange == escape(settings.ProjectStatus[1]));
	if (isDeclined && !enableDeclined) {
		settings.SelectectContactsTemp = _.filter(settings.SelectectContactsTemp, function (contact) {
			if (contact !== parseInt(lastProjectContactId))
				return true;
		});
	}

	if (gridITBGroupBy == 'view_default') {
		if (isDeclined) {
			if (!enableDeclined)
				gridITB.cells(lastProjectContactId, GetCheckboxColIndex(gridITB)).setChecked(false);
			gridITB.cells(lastProjectContactId, GetCheckboxColIndex(gridITB)).setDisabled(!enableDeclined);
		}
		else
			gridITB.cells(lastProjectContactId, GetCheckboxColIndex(gridITB)).setDisabled(false);

		gridITB.cells(lastProjectContactId, gridITB.columnIds.length - 2).setAttribute('title', decodeURIComponent(statusChange));
	}
	else {
		var subgrid = gridITB.cells(gridITB.getSelectedRowId(), 0).getSubGrid();
		if (subgrid.doesRowExist(lastProjectContactId)) {
			if (isDeclined) {
				if (!enableDeclined)
					subgrid.cells(lastProjectContactId, GetCheckboxColIndex(subgrid)).setChecked(false);
				subgrid.cells(lastProjectContactId, GetCheckboxColIndex(subgrid)).setDisabled(!enableDeclined);
			}
			else
				subgrid.cells(lastProjectContactId, GetCheckboxColIndex(subgrid)).setDisabled(false);

			subgrid.cells(lastProjectContactId, 4).setAttribute('title', decodeURIComponent(statusChange));
		}
	}

	// todo: update header row status counts depending on view type
	if (gridITBGroupBy == 'view_group') {
		statusSubGrid = gridITB.cells(gridITB.getSelectedRowId(), 0).getSubGrid();
		scl = Array();

		// iterate through all rows of the subgrid and count statuses
		statusSubGrid.forEachRow(function (id) {
			var status = jQuery('select.project-status', jQuery(statusSubGrid.cells(id, GetProjectStatusColIndex()).cell)).val();
			var i = 0;
			var found = false;
			for (i = 0; i < scl.length; i++) {
				if (scl[i][0] == status) {
					scl[i][1] += 1;
					found = true;
				}
			}
			if (!found)
				scl.push(Array(status, 1));
		});

		var newValue = '';
		scl.sort(statusCountSort);
		var i = 0;
		for (i = 0; i < scl.length; i++) {
			newValue += decodeURIComponent(scl[i][0]) + ' (' + scl[i][1].toString() + '), '
		}
		if (newValue.length > 0)
			newValue = newValue.substring(0, newValue.length - 2);

		// update parent row's status column
		gridITB.cells(gridITB.getSelectedRowId(), 2).setValue(newValue);
	}
}

function ProjectStatusChangeCancel() {
	if (gridITBGroupBy == 'view_default') {
		gridITB.forEachRow(function (id) {
			if (id == lastProjectContactId)
				gridITB.cells(id, GetProjectStatusColIndex()).setValue(lastStatus);
		});
		gridITB.setUserData(lastProjectContactId, 'ProjectStatus', lastStatus);
	}
}

function statusCountSort(a, b) {
	if (a[0] > b[0] && a[0] == 'PENDING')
		return -1;
	if (a[0] < b[0] && b[0] == 'PENDING')
		return 1;
	if (a[0] < b[0])
		return -1;
	if (a[0] > b[0])
		return 1;

	return 0;
}

function MessageStatusChange(sender, id) {
	PanteraScript.PanteraScriptService.SetProjectMessageStatus(PJQ.app.session.id, id, decodeURIComponent(jQuery(sender).val()), null, onScriptError);
	var isDeclined = (jQuery(sender).val() == escape(settings.ProjectStatus[1]));

	if (gridITBGroupBy == 'view_message') {
		statusSubGrid = gridITB.cells(gridITB.getSelectedRowId(), 0).getSubGrid();

		if (statusSubGrid.doesRowExist(id)) {
			if (isDeclined) {
				if (!enableDeclined)
					statusSubGrid.cells(id, GetCheckboxColIndex(statusSubGrid)).setChecked(false);
				statusSubGrid.cells(id, GetCheckboxColIndex(statusSubGrid)).setDisabled(!enableDeclined);
			}
			else
				statusSubGrid.cells(id, GetCheckboxColIndex(statusSubGrid)).setDisabled(false);
			statusSubGrid.cells(id, 4).setAttribute('title', decodeURIComponent(jQuery(sender).val()));
		}

		scl = Array();

		// iterate through all rows of the subgrid and count statuses
		statusSubGrid.forEachRow(function (id) {
			var status = jQuery('select.project-status', jQuery(statusSubGrid.cells(id, 4).cell)).val();
			var i = 0;
			var found = false;
			for (i = 0; i < scl.length; i++) {
				if (scl[i][0] == status) {
					scl[i][1] += 1;
					found = true;
				}
			}
			if (!found)
				scl.push(Array(status, 1));
		});

		var newValue = '';
		scl.sort(statusCountSort);
		var i = 0;
		for (i = 0; i < scl.length; i++) {
			newValue += decodeURIComponent(scl[i][0]) + ' (' + scl[i][1].toString() + '), ';
		}
		if (newValue.length > 0)
			newValue = newValue.substring(0, newValue.length - 2);

		// update parent row's status column
		gridITB.cells(gridITB.getSelectedRowId(), GetProjectStatusColIndex()).setValue(newValue);
	}
}

function eXcell_project_status_master(cell) { // project status
	if (cell) { //default pattern, just copy it
		this.cell = cell;
		this.grid = this.cell.parentNode.grid;
	}
	this.edit = function () {
	}
	//read-only cell doesn't have edit method
	this.isDisabled = function () {
		return true;
	} // the cell is read-only, that's why it is always in the disabled state
	this.setValue = function (val) {

		var template = "<select class='project-status' pjq-row-id='" + this.cell.parentNode.idd + "' onfocus='lastStatus = jQuery(this).val(); return true;' onchange='ProjectStatusChange(this," + this.cell.parentNode.idd + ")'>";

		var i = 0;
		var isSelected = '';
		if (val == '' || val == 'PENDING')
			isSelected = "selected='selected'";
		template += "<option value='PENDING' " + isSelected + ">PENDING</option>";
		for (i = 0; i < settings.ProjectStatus.length; i++) {
			isSelected = '';
			if (val == settings.ProjectStatus[i])
				isSelected = "selected='selected'";
			if (settings.ProjectStatus[i] !== 'PENDING' && settings.ProjectStatus[i] !== 'UNSENT') {
				template += "<option value='" + encodeURIComponent(settings.ProjectStatus[i]) + "' " + isSelected + ">" + settings.ProjectStatus[i] + "</option>";
			}
		}

		template += "</select>";

		this.setCValue(template);
		this.setAttribute('title', val);
	}
}

eXcell_project_status_master.prototype = new eXcell; // nest all other methods from base class

function eXcell_project_status(cell) { // project status
	if (cell) { //default pattern, just copy it
		this.cell = cell;
		this.grid = this.cell.parentNode.grid;
	}
	this.edit = function () {
	}
	//read-only cell doesn't have edit method
	this.isDisabled = function () {
		return true;
	} // the cell is read-only, that's why it is always in the disabled state
	this.setValue = function (val) {

		var template = "<select class='project-status' pjq-row-id='" + this.cell.parentNode.idd + "' onchange='MessageStatusChange(this," + this.cell.parentNode.idd + ")'>";

		var i = 0;
		var isSelected = '';
		if (val == '' || val == 'PENDING')
			isSelected = "selected='selected'";
		template += "<option value='PENDING' " + isSelected + ">PENDING</option>";
		for (i = 0; i < settings.ProjectStatus.length; i++) {
			isSelected = '';
			if (val == settings.ProjectStatus[i])
				isSelected = "selected='selected'";
			if (settings.ProjectStatus[i] !== 'PENDING' && settings.ProjectStatus[i] !== 'UNSENT') {
				template += "<option value='" + encodeURIComponent(settings.ProjectStatus[i]) + "' " + isSelected + ">" + settings.ProjectStatus[i] + "</option>";
			}
		}

		template += "</select>";

		this.setCValue(template);
		this.setAttribute('title', val);
	}
}

eXcell_project_status.prototype = new eXcell; // nest all other methods from base class

function eXcell_message_status(cell) { // project status
	if (cell) { //default pattern, just copy it
		this.cell = cell;
		this.grid = this.cell.parentNode.grid;
	}
	this.edit = function () {
	}
	//read-only cell doesn't have edit method
	this.isDisabled = function () {
		return true;
	} // the cell is read-only, that's why it is always in the disabled state
	this.setValue = function (val) {

		var template = "<select class='project-status' pjq-row-id='" + this.cell.parentNode.idd + "' onchange='MessageStatusChange(this," + this.cell.parentNode.idd + ")'>";

		var i = 0;
		var isSelected = '';
		if (val == '' || val == 'PENDING')
			isSelected = "selected='selected'";
		template += "<option value='PENDING' " + isSelected + ">PENDING</option>";
		for (i = 0; i < settings.MessageStatus.length; i++) {
			isSelected = '';
			if (val == settings.MessageStatus[i])
				isSelected = "selected='selected'";
			if (settings.MessageStatus[i] !== 'PENDING' && settings.MessageStatus[i] !== 'UNSENT') {
				template += "<option value='" + encodeURIComponent(settings.MessageStatus[i]) + "' " + isSelected + ">" + settings.MessageStatus[i] + "</option>";
			}
		}

		template += "</select>";

		this.setCValue(template);
		this.setAttribute('title', val);
	}
}

eXcell_message_status.prototype = new eXcell; // nest all other methods from base class


function ShowDetails(sender, rowId) {
	var g = jQuery(sender).parent().parent().parent().parent().parent().parent()[0].grid;
	var sg = g.cells(rowId, 0);
	if (sg && sg.isOpen && sg.isOpen())
		sg.close();
	else
		sg = null;
	jQuery("td.hideable", jQuery(sender).parent().parent().parent()).removeClass("pjq-hidden");
	jQuery("td.show-details", jQuery(sender).parent().parent().parent()).addClass("pjq-hidden");
	jQuery("td.hide-details", jQuery(sender).parent().parent().parent()).removeClass("pjq-hidden");
	if (sg) {
		sg.open();
	}
	if (gridITBGroupBy != 'view_default')
		g.callEvent("onGridReconstructed", []);
	g.setSizes();
	gridITB.setSizes();
	return false;
}

function HideDetails(sender, rowId) {
	var g = jQuery(sender).parent().parent().parent().parent().parent().parent()[0].grid;
	var sg = g.cells(rowId, 0);
	if (sg && sg.isOpen && sg.isOpen())
		sg.close();
	else
		sg = null;
	jQuery("td.hideable", jQuery(sender).parent().parent().parent()).addClass("pjq-hidden");
	jQuery("td.show-details", jQuery(sender).parent().parent().parent()).removeClass("pjq-hidden");
	jQuery("td.hide-details", jQuery(sender).parent().parent().parent()).addClass("pjq-hidden");
	if (sg) {
		sg.open();
	}
	if (gridITBGroupBy != 'view_default')
		g.callEvent("onGridReconstructed", []);
	g.setSizes();
	gridITB.setSizes();
	return false;
}

function ContactInfoContext(ev, sender) {
	ClearSubgridRowSelections();
	var cell = jQuery(sender).parent();

	cell.next().trigger({
		type: 'click',
		button: 0
	});
	cell.trigger({
		type: 'mousedown',
		button: 2
	}).trigger({
		type: 'mouseup'
	});

	var contextMenu = cmITB_P;
	if (gridITBGroupBy == 'view_message')
		contextMenu = cmITB_PMR;

	contextMenu.showContextMenu(ev.pageX, ev.pageY);
}

function ClearSubgridRowSelections() {
	gridITB.forEachRow(function (id) {
		if (gridITBGroupBy == 'view_default' && GetGroupsSubGridColIndex() != -1) {
			var subgrid = gridITB.cells(id, GetGroupsSubGridColIndex()).getSubGrid();
			if (subgrid)
				subgrid.clearSelection();
		}
		var subrid2 = gridITB.cells(id, 0).getSubGrid();
		if (subrid2) {
			subrid2.clearSelection();
			if (gridITBGroupBy == 'view_group' || gridITBGroupBy == 'view_response' || gridITBGroupBy == 'view_scope')
				subrid2.forEachRow(function (id2) {
					if (gridITBGroupBy == 'view_group' || gridITBGroupBy == 'view_scope') {
						var subgrid3 = subrid2.cells(id2, GetGroupsSubGridColIndex()).getSubGrid();
						if (subgrid3)
							subgrid3.clearSelection();
					}
					var subgrid4 = subrid2.cells(id2, 0).getSubGrid();
					if (subgrid4)
						subgrid4.clearSelection();
				})
		}
	});
}

function ContactInfoClick(ev, sender) {
	ClearSubgridRowSelections();
	var cell = jQuery(sender).parent();
	cell.trigger({
		type: 'click',
		button: 2
	});

	var contextMenu = cmITB_P;
	if (gridITBGroupBy == 'view_message')
		contextMenu = cmITB_PMR;

	contextMenu.hideContextMenu();
}

function ExplainMe(sender) {
	var what = jQuery(sender).attr('alt');
	alert(what);
}

function eXcell_contactinfo(cell) { // contact info
	if (cell) { //default pattern, just copy it
		this.cell = cell;
		this.grid = this.cell.parentNode.grid;
	}
	this.edit = function () {
	}
	//read-only cell doesn't have edit method
	this.isDisabled = function () {
		return true;
	} // the cell is read-only, that's why it is always in the disabled state
	this.setValue = function (val) {

		var parts = val.split("|||");
		var title = parts[0];
		if (!title)
			title = parts[6];

		var rowCount = 6;
		if (parts[4])
			rowCount++;
		if (parts[5])
			rowCount++;
		if (parts[6])
			rowCount++;
		if (parts[7])
			rowCount++;
		if (parts[8])
			rowCount++;

		if (parts.length > 16)
			rowCount += (parts.length - 16) / 2;

		var icons = '&nbsp;';
		var iconsClass = 'ci-icon-hidden';
		if (false && settings.IsShowLastBroadcastStatus) // broadcast status
		{
			iconsClass = 'ci-icon';

			if (parts[16]) // broadcast status
				icons = "<img src='/images/icon_viewstats_16px.gif' alt='Last Message Failed'  onclick='ExplainMe(this)' /></br>";
		}

		var linethrough = '';
		if (this.grid.getUserData(this.cell.parentNode.idd, 'IsBlacklisted') == 'true')
			linethrough = " style='text-decoration:line-through;' ";

		var template = "<table border='0' class='contact-info-table' " + linethrough + " onclick='ContactInfoClick(event, this);' oncontextmenu='ContactInfoContext(event, this);'>";
		template = template + "<tr><td class='" + iconsClass + "' nowrap='nowrap' valign='top' rowspan='" + rowCount.toString() + "'>" + icons + "</td><td class='company-name' colspan='2'>" + parts[0] + "</td></tr>";
		if (parts[2])
			template = template + "<tr><td colspan='2'>" + parts[1] + " (" + parts[2] + ")</td></tr>";
		else
			template = template + "<tr><td colspan='2'>" + parts[1] + "</td></tr>";

		template = template + "<tr><td class='pjq-field-label'>Phone:</td><td >" + parts[3] + "</td></tr>";
		if (parts[6])
			template = template + "<tr><td class='pjq-field-label'>Email</td><td class='company-email'><a href='mailto:" + parts[6] + "'>" + parts[6] + "</a></td></tr>";
		if (parts.length > 13) {
			var ii = 0;
			for (ii = 17; ii < parts.length; ii += 2)
				template = template + "<tr><td class='pjq-field-label'>" + parts[ii] + ":</td><td >" + parts[ii + 1] + "</td></tr>";
		}
		template = template + "<tr><td colspan='2' class='show-details'><a href='javascript:void(0)' onclick='ShowDetails(this, " + this.cell.parentNode.idd + "); event.preventDefault();'>Show More...</a></td></tr>";

		if (parts[4])
			template = template + "<tr><td class='pjq-field-label pjq-hidden hideable'>Fax</td><td class='pjq-hidden hideable'>" + parts[4] + "</td></tr>";
		if (parts[5])
			template = template + "<tr><td class='pjq-field-label pjq-hidden hideable'>Cell</td><td class='pjq-hidden hideable'>" + parts[5] + "</td></tr>";
		if (parts[7])
			template = template + "<tr><td class='pjq-field-label pjq-hidden hideable'>Address 1</td><td class='pjq-hidden hideable'>" + parts[7] + "</td></tr>";
		if (parts[8])
			template = template + "<tr><td class='pjq-field-label pjq-hidden hideable'>Address 2</td><td class='pjq-hidden hideable'>" + parts[8] + "</td></tr>";

		var location = parts[9];
		if (parts[10]) {
			if (location)
				location = location + ', ';

			location = location + parts[10];
		}
		if (parts[11]) {
			if (location)
				location = location + ' ';

			location = location + parts[11];
		}
		if (parts[12]) {
			if (location)
				location = location + ' ';

			location = location + parts[12];
		}
		if (location)
			template = template + "<tr><td class='pjq-field-label pjq-hidden hideable'>City, State, Zip</td><td class='pjq-hidden hideable'>" + location + "</td></tr>";

		template = template + "<tr><td colspan='2' class='hide-details pjq-hidden'><a href='javascript:void(0)' onclick='HideDetails(this, " + this.cell.parentNode.idd + "); event.preventDefault();'>Show Less...</a></td></tr>";
		template = template + "</table>";
		this.setCValue(template);
	}
}

eXcell_contactinfo.prototype = new eXcell; // nest all other methods from base class
eXcell_contactinfo.prototype.getTitle = function () {

	var tip = jQuery("td.company-name", jQuery(this.cell)).text();
	if (!tip)
		tip = jQuery("td.company-email", jQuery(this.cell)).text();

	if (tip)
		return tip;

	return this.cell.innerHTML;
}

function eXcell_broadcast_status(cell) { // broadcast status
	if (cell) { //default pattern, just copy it
		this.cell = cell;
		this.grid = this.cell.parentNode.grid;
	}
	this.edit = function () {
	}
	//read-only cell doesn't have edit method
	this.isDisabled = function () {
		return true;
	} // the cell is read-only, that's why it is always in the disabled state
	this.setValue = function (val) {

		var parts = val.split("|||");
		var template = parts[0];
		if (parts[1]) {
			template = "<a href='javascript:void(0)' title='" + encodeURIComponent(parts[1]) + "' >" + parts[0] + "</a>";
		}

		this.setCValue(template);
	}
}

eXcell_broadcast_status.prototype = new eXcell; // nest all other methods from base class

/************ MISCINFO ************/
function eXcell_miscinfo_itb(cell) { // contact info
	if (cell) { //default pattern, just copy it
		this.cell = cell;
		this.grid = this.cell.parentNode.grid;
	}
	this.edit = function () {
	}
	//read-only cell doesn't have edit method
	this.isDisabled = function () {
		return true;
	} // the cell is read-only, that's why it is always in the disabled state
	this.setValue = function (val) {

		var parts = val.split("|||");
		var notes = '';
		if (parts[1])
			notes = parts[1];
		var template = "<div style='width: 98%; height: 100%; padding: 2px;'><span class='pjq-field-label'>Notes:</span><br /><textarea class='contact-notes' onkeydown='ContactMiscInfoChanged(this)' onBlur='ContactMiscNotesITBAutoSave(this, " + this.cell.parentNode.idd + ");'>" + notes + "</textarea><br />";
		template += "<span class='pjq-field-label'>Bid Amount:</span> <input type='text' class='contact-bid-amount' value='" + parts[0] + "' onkeydown='ContactMiscInfoChanged(this);' onchange='jQuery(this).val( parseFloat(jQuery(this).val()).toFixed(2).toString());' />&nbsp;&nbsp;<img class='contact-misc-save pjq-hidden' src='/i/save2.gif' title='Save' onclick='ContactMiscInfoSave(this, " + this.cell.parentNode.idd + ");' /> <img class='contact-misc-cancel pjq-hidden' src='/i/cancelb.gif' title='Cancel' onclick='ContactMiscInfoCancel(this);' /><input type='hidden' class='contact-misc-notes-original' /><input type='hidden' class='contact-misc-bidamount-original' /></div>";

		this.setCValue(template);
	}
}

eXcell_miscinfo_itb.prototype = new eXcell; // nest all other methods from base class
eXcell_miscinfo_itb.prototype.getTitle = function () {

	var tip = 'Notes: ' + jQuery("textarea.contact-notes", jQuery(this.cell)).val();

	if (tip)
		return tip;

	return this.cell.innerHTML;
}

function ContactMiscInfoChanged(sender) {
	if (jQuery("img.contact-misc-save", jQuery(sender).parent()).hasClass("pjq-hidden")) {
		jQuery("input.contact-misc-notes-original", jQuery(sender).parent()).val(jQuery("textarea.contact-notes", jQuery(sender).parent()).val());
		jQuery("input.contact-misc-bidamount-original", jQuery(sender).parent()).val(jQuery("input.contact-bid-amount", jQuery(sender).parent()).val());
		jQuery("img.contact-misc-save,img.contact-misc-cancel", jQuery(sender).parent()).removeClass("pjq-hidden");
	}
}

function ContactMiscInfoSave(sender, id) {
	jQuery("img.contact-misc-save,img.contact-misc-cancel", jQuery(sender).parent()).addClass("pjq-hidden");
	var bidAmount = jQuery("input.contact-bid-amount", jQuery(sender).parent()).val();
	if (!bidAmount)
		bidAmount = '0.00';

	bidAmount = bidAmount.replace(/,/g, "");

	var now = new Date();
	if (settings.IsNotesAutoTimestamp && jQuery(".contact-notes", jQuery(sender).parent()).val().length > 0) {
		jQuery(".contact-notes", jQuery(sender).parent()).val(jQuery(".contact-notes", jQuery(sender).parent()).val() + "\nEdited: " + now.toLocaleString().replace(/\u200E/g, '') + " by " + settings.UserDisplayName);
	}

	PanteraScript.PanteraScriptService.SetProjectContactMisc(PJQ.app.session.id, id, jQuery("textarea.contact-notes", jQuery(sender).parent()).val(), parseFloat(bidAmount), null, onScriptError);
}

function ContactMiscNotesITBAutoSave(sender, id) {
	if (settings.IsNotesAutoSaveEnabled)
		ContactMiscInfoSave(sender, id);
	return true;
}

function ContactMiscInfoCancel(sender) {
	jQuery("img.contact-misc-save,img.contact-misc-cancel", jQuery(sender).parent()).addClass("pjq-hidden");
	jQuery("textarea.contact-notes", jQuery(sender).parent()).val(jQuery("input.contact-misc-notes-original", jQuery(sender).parent()).val());
	jQuery("input.contact-bid-amount", jQuery(sender).parent()).val(jQuery("input.contact-misc-bidamount-original", jQuery(sender).parent()).val());
}

/******************* ITB NOTES *******************/
function eXcell_notes_itb(cell) { // contact info
	if (cell) { //default pattern, just copy it
		this.cell = cell;
		this.grid = this.cell.parentNode.grid;
	}
	this.edit = function () {
	}
	//read-only cell doesn't have edit method
	this.isDisabled = function () {
		return true;
	} // the cell is read-only, that's why it is always in the disabled state
	this.setValue = function (val) {

		var template = "<div class='contact-notes-container' style='width: 98%; height: 70px; padding: 2px;'><textarea class='contact-notes' style='height: 90%;' onBlur='ContactNotesITBAutoSave(this, " + this.cell.parentNode.idd + ");' onkeydown='jQuery(this).css(\"height\",\"64%\"); return ContactMiscInfoChanged(this);'>" + val + "</textarea><br />";
		template += "<img class='contact-misc-save pjq-hidden' src='/i/save2.gif' title='Save' onclick='jQuery(\"textarea.contact-notes\",jQuery(this).parent()).css(\"height\",\"90%\"); ContactNotesITBSave(this, " + this.cell.parentNode.idd + ");' /> <img class='contact-misc-cancel pjq-hidden' src='/i/cancelb.gif' title='Cancel' onclick='jQuery(\"textarea.contact-notes\",jQuery(this).parent()).css(\"height\",\"90%\"); ContactNotesITBCancel(this);' /><input type='hidden' class='contact-misc-notes-original' /></div>";

		this.setCValue(template);
	}
}

eXcell_notes_itb.prototype = new eXcell; // nest all other methods from base class
eXcell_notes_itb.prototype.getTitle = function () {

	var tip = 'Notes: ' + jQuery("textarea.contact-notes", jQuery(this.cell)).val();

	if (tip)
		return tip;

	return this.cell.innerHTML;
}

function ContactNotesITBAutoSave(sender, id) {
	if (settings.IsNotesAutoSaveEnabled)
		ContactNotesITBSave(sender, id);
	return true;
}

function ContactNotesITBChanged(sender) {
	if (jQuery("img.contact-misc-save", jQuery(sender).parent()).hasClass("pjq-hidden")) {
		jQuery("input.contact-misc-notes-original", jQuery(sender).parent()).val(jQuery(".contact-notes", jQuery(sender).parent()).val());
		jQuery("img.contact-misc-save,img.contact-misc-cancel", jQuery(sender).parent()).removeClass("pjq-hidden");
	}
}

function ContactNotesITBSave(sender, id) {

	var now = new Date();
	if (settings.IsNotesAutoTimestamp && jQuery(".contact-notes", jQuery(sender).parent()).val().length > 0) {
		jQuery(".contact-notes", jQuery(sender).parent()).val(jQuery(".contact-notes", jQuery(sender).parent()).val() + "\nEdited: " + now.toLocaleString().replace(/\u200E/g, '') + " by " + settings.UserDisplayName);
	}

	jQuery("img.contact-misc-save,img.contact-misc-cancel", jQuery(sender).parent()).addClass("pjq-hidden");
	PanteraScript.PanteraScriptService.SetProjectContactNotes(PJQ.app.session.id, id, jQuery(".contact-notes", jQuery(sender).parent()).val(), null, onScriptError);
}

function ContactNotesITBCancel(sender) {
	jQuery("img.contact-misc-save,img.contact-misc-cancel", jQuery(sender).parent()).addClass("pjq-hidden");
	jQuery(".contact-notes", jQuery(sender).parent()).val(jQuery("input.contact-misc-notes-original", jQuery(sender).parent()).val());
}

/******************* ITB NOTES *******************/
function eXcell_notes_itb_single(cell) { // contact info
	if (cell) { //default pattern, just copy it
		this.cell = cell;
		this.grid = this.cell.parentNode.grid;
	}
	this.edit = function () {
	}
	//read-only cell doesn't have edit method
	this.isDisabled = function () {
		return true;
	} // the cell is read-only, that's why it is always in the disabled state
	this.setValue = function (val) {

		var template = "<div style='width: 98%; padding: 2px;'><input class='contact-notes-single' style='width:100%;' onkeydown='ContactNotesITBSingleChanged(this); ' onkeypress='ContactNotesITBSingleKeypress(event, this, " + this.cell.parentNode.idd + ");' onBlur='ContactNotesITBSingleAutoSave(this, " + this.cell.parentNode.idd + ");' value='" + $('<div/>').text(val).html() + "' />&nbsp;";
		template += "<img class='contact-misc-save pjq-hidden' src='/i/save2.gif' title='Save' onclick='ContactNotesITBSingleSave(this, " + this.cell.parentNode.idd + ");' /> <img class='contact-misc-cancel pjq-hidden' src='/i/cancelb.gif' title='Cancel' onclick='ContactNotesITBSingleCancel(this);' /><input type='hidden' class='contact-misc-notes-original' /></div>";

		this.setCValue(template);
	}
}

eXcell_notes_itb_single.prototype = new eXcell; // nest all other methods from base class
eXcell_notes_itb_single.prototype.getTitle = function () {

	var tip = 'Notes: ' + jQuery("input.contact-notes-single", jQuery(this.cell)).val();

	if (tip)
		return tip;

	return this.cell.innerHTML;
}

function ContactNotesITBSingleKeypress(event, sender, id) {
	if (event.which == 13) {
		event.preventDefault();
		var savebtn = jQuery("img.contact-misc-save", jQuery(sender).parent());
		ContactNotesITBSingleSave(savebtn, id);
	}
}

function ContactNotesITBSingleAutoSave(sender, id) {
	if (settings.IsNotesAutoSaveEnabled)
		ContactNotesITBSingleSave(sender, id);
	return true;
}

function ContactNotesITBSingleChanged(sender) {
	if (jQuery("img.contact-misc-save", jQuery(sender).parent()).hasClass("pjq-hidden")) {
		jQuery(".contact-notes-single", jQuery(sender).parent()).css('width', '70%');
		jQuery(sender).siblings('input.contact-misc-notes-original').val(jQuery(sender).val());
		jQuery("img.contact-misc-save,img.contact-misc-cancel", jQuery(sender).parent()).removeClass("pjq-hidden");
	}
}

function ContactNotesITBSingleSave(sender, id) {

	var now = new Date();
	if (settings.IsNotesAutoTimestamp && jQuery(".contact-notes-single", jQuery(sender).parent()).val().length > 0) {
		jQuery(".contact-notes-single", jQuery(sender).parent()).val(jQuery(".contact-notes-single", jQuery(sender).parent()).val() + " Edited: " + now.toLocaleString().replace(/\u200E/g, '') + " by " + settings.UserDisplayName);
	}

	jQuery("img.contact-misc-save,img.contact-misc-cancel", jQuery(sender).parent()).addClass("pjq-hidden");
	jQuery(".contact-notes-single", jQuery(sender).parent()).css('width', '100%');
	PanteraScript.PanteraScriptService.SetProjectContactNotes(PJQ.app.session.id, id, jQuery(".contact-notes-single", jQuery(sender).parent()).val(), null, onScriptError);
}

function ContactNotesITBSingleCancel(sender) {
	jQuery("img.contact-misc-save,img.contact-misc-cancel", jQuery(sender).parent()).addClass("pjq-hidden");
	jQuery(".contact-notes-single", jQuery(sender).parent()).css('width', '100%');
	jQuery(sender).siblings('.contact-notes-single').val(jQuery(sender).siblings('.contact-notes-single').val());
}

function sort_distance(a, b, order) {

	if (a)
		a = a.toString().replace(/\,/g, '');

	if (b)
		b = b.toString().replace(/\,/g, '');

	var aFloat = parseFloat(a);
	if (isNaN(aFloat))
		aFloat = 0.0;
	var bFloat = parseFloat(b);
	if (isNaN(bFloat))
		bFloat = 0.0;

	if (order == "asc")
		return (aFloat > bFloat ? 1 : -1);
	else
		return (aFloat > bFloat ? -1 : 1);
}

function GetRowStyle(grid, id) {
	var style = grid.getRowAttribute(id, 'style');

	if (!style)
		style = '';

	return style;
}

var copyDialog;

function copyDirectoryContactItb(contactId) {
	copyDialog = showInfoDialogPWall('Copying', '<b>Copying Directory Contact...</b>', '', 'no-buttons');
	PanteraScript.PanteraScriptService.CopyDirectoryContact(PJQ.app.session.id, contactId, copyDirectoryContactItbC, onScriptError);
}

function copyDirectoryContactItbC(response) {
	if (copyDialog)
		copyDialog.dialog('destroy');
	if (response > 0) {
		showInfoDialogPWall('Copying', 'This directory contact was successfully copied to your address book.', '', '');
	}
	else if (response == -1) {
		showInfoDialogPWall('Copy Failed', 'This directory contact is already in your address book.', '', '');
	}
	else {
		showInfoDialogPWall('Copy Failed', 'Failed to copy this directory contact.  Please contact an administrator.', '', '');
	}
}

function viewParticipantsDownloads(projectContactId) {
	if (projectContactId > 0) {
		jQuery("#participantDownloadsDialog").dialog({
			resizable: false,
			height: 'auto',
			width: 600,
			title: 'Download History',
			modal: true,
			buttons: {
				"Export": function () {
					ShowBusyITB("Exporting...");
					PanteraScript.PanteraScriptService.ExportParticipantDownloads(PJQ.app.session.id, projectContactId, function (response) {
						HideBusy("Exporting...");
						showInfoDialogPWall('Export Complete', '<a href="' + response + '">Click here to download your export.</a>', 'ui-icon-info');
					}, onScriptError);
				}
			}
		});
		var participantDownloadsGrid = new dhtmlXGridObject('participantDownloadsGrid');
		participantDownloadsGrid.setImagePath('/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/');
		participantDownloadsGrid.setSkin(pjqGridTheme);
		participantDownloadsGrid.enableAutoHeight(true);
		participantDownloadsGrid.enablePaging(true, 10, 3, "participantDownloadsGridPaging", true);
		participantDownloadsGrid.setPagingSkin("toolbar", "dhx_web");
		participantDownloadsGrid.setDragBehavior('complex');
		participantDownloadsGrid.setDelimiter('|');
		participantDownloadsGrid.loadXML('/DesktopModules/PJQProjectWallAdmin/GetParticipantDownloads.aspx?sessionId=' + PJQ.app.session.id + '&pc=' + projectContactId);
		participantDownloadsGrid.init();
		participantDownloadsGrid.attachEvent("onXLE", function (grid_obj, count) {

			participantDownloadsGrid.setSizes();
		});
	}
}

function SendContactUpdater() {
	PanteraScript.PanteraScriptService.ResendContactUpdater(PJQ.app.session.id, parseInt(lastContactId), ContactUpdateC, onScriptError);
}

function ContactUpdateC() {
}
